(function () {

  "use strict";



  const cfg = window.KB_TABLE_CONFIG || {};

  const root = document.querySelector("[data-kb-table-designer]");

  if (!root || !cfg.saveUrl) return;



  const form = root.querySelector("[data-kb-table-form]");

  const preview = root.querySelector("[data-kb-preview]");

  const selectionSummary = root.querySelector("[data-kb-selection-summary]");

  const message = root.querySelector("[data-kb-message]");

  const autosaveStatus = root.querySelector("[data-kb-autosave-status]");

  const cartCheck = root.querySelector("[data-kb-cart-check]");

  const addButton = root.querySelector("[data-kb-add]");

  const priceNodes = root.querySelectorAll("[data-kb-price], [data-kb-price-mobile]");

  const alternateShapes = root.querySelector("[data-kb-alternate-shapes]");

  const alternateShapesGrid = root.querySelector("[data-kb-alternate-shapes-grid]");

  const contrastWarning = root.querySelector("[data-kb-contrast-warning]");

  const mobileCheckoutBar = root.querySelector("[data-kb-mobile-checkout]");

  const mobileOpenButton = root.querySelector("[data-kb-mobile-open]");

  const mobileOpenDefaultText = mobileOpenButton ? mobileOpenButton.textContent : "Personalizuj";

  const mobileCloseButton = root.querySelector("[data-kb-mobile-close]");

  const dimensionOptions = root.querySelector("[data-kb-dimension-options]");

  const customDimWrap = root.querySelector("[data-kb-custom-dim]");

  const customWidthInput = root.querySelector('[name="custom_width"]');

  const customHeightInput = root.querySelector('[name="custom_height"]');

  let customDimActive = false;

  const selectedDimensionLabel = root.querySelector("[data-kb-selected-dimension]");

  const shapeCurrentLabel = root.querySelector("[data-kb-shape-current]");

  const dogSymbolPicker = root.querySelector("[data-kb-dog-symbol-picker]");

  const dogSymbolSearch = root.querySelector("[data-kb-dog-symbol-search]");

  const dogSymbolGrid = root.querySelector("[data-kb-dog-symbol-grid]");

  const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"], product-form [name="id"]');

  const rootPlaceholder = document.createComment("kb-table-designer-anchor");

  if (root.parentNode) root.parentNode.insertBefore(rootPlaceholder, root);

  const wizardSteps = ["text", "colors", "details"];

  const wizardStepTitles = {

    text: "Tekst",

    colors: "Boje",

    details: "Detalji"

  };

  const wizardStepActions = {

    text: "Izaberi boje",

    colors: "Dodaj detalje",

    details: "Dodaj u korpu"

  };



  let lastDesign = null;

  let dirty = true;

  let renderTimer = null;

  let alternateRenderTimer = null;

  let alternateRenderSeq = 0;

  let rendererModulePromise = null;

  let dogSymbols = [];

  let dogSmartNames = {};

  let activeTextField = form ? form.querySelector('[name="street"]') : null;

  let dimResizeObserver = null;

  let galleryPreviewActive = false;

  let galleryPreview = null;

  let activeStepLockUntil = 0;

  let contactPhoneTimer = null;

  let lastIdentifiedContactPhone = "";

  let phoneIdentifyPromise = null;

  let draftSaveTimer = null;

  let draftAnalyticsTimer = null;

  let autosaveStatusTimer = null;

  let saveToastTimer = null;

  let lastDraftAnalyticsAt = 0;

  let restoringDraft = false;

  let relatedPrefillReported = false;

  // Measurement state is page-local; restored/prefilled text is the baseline.
  let primaryTextBaseline = null;
  const primaryTextTouched = { street: false, number: false };
  let primaryTextEditReported = false;
  let configuratorOpenedReported = false;
  let configuratorVisibilityObserver = null;
  let initialDraftSource = "default";

  const transliterationTimers = new WeakMap();

  const LS_ANON_ID = "gs_anon_id";

  const LS_LEAD_ID = "gs_lead_id";

  const LS_SESSION_ID = "gs_session_id";

  const LS_LAST_ACTIVITY = "gs_last_activity";

  const LS_META_LEAD_EVENT_PREFIX = "gs_meta_lead_event_sent:";
  const LS_DESIGN_DRAFT_PREFIX = "kb_table_design_draft:";
  const LS_DESIGN_TEXT_PREFIX = "kb_table_design_last_text:";
  const LS_RENDER_ERROR_PREFIX = "kb_table_render_error:";
  const SESSION_TIMEOUT_MS = 30 * 60 * 1000;
  const DRAFT_SAVE_DELAY_MS = 350;

  const DRAFT_ANALYTICS_DELAY_MS = 12000;

  const DRAFT_ANALYTICS_MIN_INTERVAL_MS = 45000;

  const CRM_EDITOR_BASE_URL = "https://app.fordservisbeograd.rs/table_designer/studio.php?design_id=";

  const MAILBOX_MIRROR_PLATE_COLORS = new Set(["srebrno_ogledalo", "zlatno_ogledalo"]);

  const HOUSE_NUMBER_RE = /^[0-9A-Za-zЀ-ӿ]+([ /-][0-9A-Za-zЀ-ӿ]+)*$/u;

  const HOUSE_NUMBER_MESSAGE = "Dozvoljeni su cifre, slova i / - (npr. 15, 15a, 15/1, bb).";

  const ENGRAVING_TEXT_RE = /^[A-Za-z0-9\u00C0-\u024F\u0400-\u04FF\s.,'&/-]+$/u;



  const swatchFills = {

    crna: "#030303",

    plava: "#002d83",

    teget: "#111934",

    bela: "linear-gradient(135deg, #ffffff 0%, #f1f1ec 100%)",

    siva: "#808080",

    antracit: "#383E42",

    braon: "#2b1611",

    srebrno_ogledalo: "linear-gradient(135deg, #7c8288 0%, #d5dbe0 34%, #f8fbfd 50%, #a1a8ae 68%, #dfe4e8 82%, #91989f 100%)",

    zlatno_ogledalo: "linear-gradient(135deg, #9a7638 0%, #ead6a0 36%, #d1ab63 54%, #f3dc96 74%, #b88f49 100%)",

    srebrna_metalik: "linear-gradient(135deg, #262626 0%, #555 42%, #1e1e1e 100%)",

    crvena: "#951218",

    srebrna: "linear-gradient(135deg, #f1f2f4 0%, #aeb4bc 50%, #d6d9dd 100%)",

    zlatna: "linear-gradient(135deg, #f6e8b0 0%, #c9a23f 50%, #e7cf86 100%)",

    srebrna_graverska: "linear-gradient(135deg, #aeb2b5 0%, #f0f0ef 38%, #c5c8ca 68%, #e2e3e3 100%)",

    zlatna_graverska: "linear-gradient(135deg, #f6e8b0 0%, #c9a23f 50%, #e7cf86 100%)",

    crna_graverska: "#030303"

  };

  const comboSolidFills = {

    crna: "#030303",

    plava: "#002d83",

    teget: "#111934",

    bela: "#f6f6f2",

    siva: "#808080",

    antracit: "#383E42",

    braon: "#2b1611",

    srebrno_ogledalo: "#cfd5da",

    zlatno_ogledalo: "#d7b15f",

    srebrna_metalik: "#555555",

    crvena: "#951218",

    srebrna: "#c9cfd5",

    zlatna: "#d1aa4f",

    srebrna_graverska: "#d3d3d3",

    zlatna_graverska: "#d1aa4f",

    crna_graverska: "#030303",

  };



  const shapeLabels = {

    moderni: "Oblik 1",

    oblik_2: "Oblik 2",

    oblik_3: "Oblik 3",

    oblik_4: "Oblik 4 - Linije",

    oblik_4_srpski: "Oblik 4 - Srpski",

    oblik_4_retro: "Oblik 4 - Retro",

    oblik_4_pola_pola: "Oblik 4 - Pola pola",

    video_nadzor: "Video nadzor",

    zabranjeno_parkiranje: "Zabranjeno parkiranje",

    cuvaj_se_psa: "Čuvaj se psa",

    postansko_sanduce: "Poštansko sanduče",

    standard: "Oblik 4",

    oblik_5: "Oblik 5",

    oblik_6: "Oblik 6",

    pojedinacni_karakter: "Pojedinačni karakteri",

    stan_plocica: "Pločica",

    plocica_oblik_1: "Pločica oblik 1",

    plocica_oblik_2: "Pločica oblik 2",

    plocica_oblik_4: "Pločica oblik 4"

  };

  const centerNumberShapes = new Set(["moderni", "standard"]);

  const houseShapeOptions = [

    { shape: "moderni", label: "Oblik 1", handlePart: "1" },

    { shape: "oblik_2", label: "Oblik 2", handlePart: "2" },

    { shape: "oblik_3", label: "Oblik 3", handlePart: "3" },

    { shape: "standard", label: "Oblik 4", handlePart: "4" },

    { shape: "oblik_4_pola_pola", label: "Oblik 4 - Pola pola", handlePart: "4-2-1-pola-pola" },

    { shape: "oblik_5", label: "Oblik 5", handlePart: "5" },

    { shape: "oblik_6", label: "Oblik 6", handlePart: "6" }

  ];

  const apartmentPlateShapeOptions = [

    { key: "plocica_oblik_1", shape: "plocica_oblik_1", label: "Pločica 1", productHandle: "plocica-1", width_cm: 12, height_cm: 5 },

    { key: "plocica_oblik_2", shape: "plocica_oblik_2", label: "Pločica 2", productHandle: "plocica-2", width_cm: 15, height_cm: 4 },

    { key: "stan_plocica", shape: "stan_plocica", label: "Pločica 3", productHandle: "plocica-3", width_cm: 15, height_cm: 4 },

    { key: "plocica_oblik_4", shape: "plocica_oblik_4", label: "Pločica 4", productHandle: "plocica-4", width_cm: 15, height_cm: 4 },

    { key: "stan_plocica_natpis", shape: "stan_plocica", label: "Pločica natpis", productHandle: "plocica-natpis", width_cm: 15, height_cm: 4, natpisOnly: true }

  ];



  // Na kvadratnim tablama (odnos 1:1) natpis NIJE obavezan - kupac moze da naruci
  // samo broj. Za razliku od isNumberOnlyShape, polje za natpis ostaje vidljivo i
  // upotrebljivo, samo prestaje da bude uslov za poruciti.
  function isSquareRatioConfig(config) {
    if (!config) return false;
    const w = Number(config.width_cm);
    const h = Number(config.height_cm);
    if (!w || !h) return false;
    return Math.abs(w - h) < 0.01;
  }
  function isStreetOptional(config) {
    return config?.shape === "oblik_4_retro" || (isSquareRatioConfig(config) && !isNumberOnlyShape(config && config.shape));
  }
  function isNumberOnlyShape(shape) {

    return shape === "oblik_4" || shape === "oblik_4_srpski";

  }



  function isTextOnlyShape(shape) {

    return shape === "video_nadzor" || shape === "zabranjeno_parkiranje" || shape === "cuvaj_se_psa" || shape === "postansko_sanduce" || shape === "pojedinacni_karakter";

  }



  function isApartmentPlateShape(shape) {

    return shape === "stan_plocica" || shape === "plocica_oblik_1" || shape === "plocica_oblik_2" || shape === "plocica_oblik_4";

  }



  function isSingleCharacterShape(shape) {

    return shape === "pojedinacni_karakter";

  }



  function physicalCharacterCount(value) {

    return Array.from(String(value || "").replace(/\s+/g, "")).length;

  }

  function unsupportedEngravingChar(value) {

    for (const ch of Array.from(String(value || ""))) {

      if (!ENGRAVING_TEXT_RE.test(ch)) return ch;

    }

    return "";

  }



  function unsupportedCharMessage(ch) {

    return `Znak "${ch}" nije podrzan za graviranje.`;

  }





  function singleCharacterValidation(value) {

    const input = String(value || "").trim();

    if (!input) return { ok: false, message: "Unesite karaktere." };

    const count = physicalCharacterCount(input);

    if (!count) return { ok: false, message: "Unesite karaktere." };

    if (count > 20) return { ok: false, message: "Maksimalno je 20 karaktera." };

    const bad = unsupportedEngravingChar(input);

    if (bad) return { ok: false, message: unsupportedCharMessage(bad) };

    return { ok: true, count, value: input };

  }



  // KB_FLOW_HELPERS_START -- independently regression tested.
  let flowStage = 'validation';
  let flowOperation = null;
  let flowAction = null;
  let flowPreviewSequence = 0;
  const flowDiagnosticTimes = new Map();
  const flowStorageKey = 'kb_design_flow:' + String(cfg.productId || cfg.productHandle || '');

  function flowError(code, stage, detail = '', extra = {}) {
    return Object.assign(new Error(detail || code), { name: 'KBFlowError', code, stage, ...extra });
  }

  function flowErrorView(error, saved = false) {
    const stage = error.stage || flowStage;
    const code = error.code || (error.name === 'AbortError' ? 'TIMEOUT' : error instanceof TypeError ? 'NETWORK' : 'UNEXPECTED');
    if (code === 'VALIDATION_ERROR') {
      const detail = String(error.message || '');
      return { text: /^(Unesite|Izaberite|Dimenzij|Maksimalno|Broj |Visina |Čuvaj se psa|Izabrani proizvod|Natpis |Dozvoljeni)/i.test(detail) ? detail : 'Proverite unete podatke i izabrane opcije.', action: 'edit' };
    }
    if (code === 'FONT_UNSUPPORTED') return { text: 'Izabrani font ne podržava neki od unetih znakova. Izaberite drugi font.', action: 'edit' };
    if (code === 'CART_UNKNOWN') return { text: 'Dodavanje još nije potvrđeno. Vaš dizajn je sačuvan. Proverićemo prethodni pokušaj pre ponovnog slanja.', action: 'cart' };
    if (code === 'CART_WAIT') return { text: 'Prethodni pokušaj se još proverava. Sačekajte malo, pa pokušajte ponovo. Vaš dizajn je sačuvan.', action: 'cart' };
    if (code === 'CART_BUSY') return { text: 'Dodavanje je već u toku u drugom prozoru. Sačekajte da se završi.', action: 'cart' };
    if (code === 'CART_PARTIAL') return { text: 'Nije dostupna cela tražena količina. Proverite dodate komade u korpi.', action: 'cart' };
    if (code === 'RATE_LIMIT' || error.status === 429) return { text: 'Sačekajte malo pre ponovnog pokušaja. Vaš unos je i dalje ovde.', action: 'retry' };
    if (code === 'FORBIDDEN' || error.status === 403) return { text: 'Zahtev nije prihvaćen. Sačuvajte svoj unos i osvežite stranicu pre ponovnog pokušaja.', action: 'none' };
    if (code === 'PAYLOAD_TOO_LARGE' || error.status === 413) return { text: 'Prikaz dizajna je prevelik za slanje. Pokušajte ponovo ili zatražite pomoć dizajnera.', action: 'retry' };
    if (code === 'CART_UNAVAILABLE') return { text: 'Izabrana varijanta ili količina trenutno nije dostupna. Izaberite drugu opciju.', action: 'edit' };
    if (stage === 'preview' || stage === 'render') return { text: 'Nismo uspeli da učitamo pregled dizajna. Vaš unos je i dalje ovde.', action: 'preview' };
    if (stage === 'cart') return { text: saved ? 'Dizajn je sačuvan, ali proizvod nije dodat u korpu. Pokušajte ponovo.' : 'Proizvod nije dodat u korpu. Pokušajte ponovo.', action: 'retry' };
    if (code === 'SAVE_IN_PROGRESS') return { text: 'Čuvanje dizajna je još u toku. Sačekajte malo, pa proverite ponovo.', action: 'retry' };
    if (code === 'NETWORK' || code === 'TIMEOUT' || code === 'INVALID_RESPONSE') return { text: 'Nismo uspeli da potvrdimo čuvanje dizajna. Vaš unos je i dalje ovde. Pokušajte ponovo.', action: 'retry' };
    return { text: 'Trenutno ne možemo da sačuvamo dizajn. Pokušajte ponovo za nekoliko trenutaka.', action: 'retry' };
  }

  async function flowFetch(url, options = {}, stage = 'save', timeoutMs = 15000) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    try {
      const response = await fetch(url, { ...options, signal: controller.signal });
      let data;
      try { data = await response.json(); } catch (e) {
        if (controller.signal.aborted) throw flowError('TIMEOUT', stage);
        throw flowError('INVALID_RESPONSE', stage, '', { status: response.status });
      }
      if (!response.ok) {
        const status = response.status;
        const code = status === 429 ? 'RATE_LIMIT' : status === 403 ? 'FORBIDDEN' : status === 413 ? 'PAYLOAD_TOO_LARGE' :
          stage === 'cart' && status === 422 ? 'CART_UNAVAILABLE' : data.code || (status === 422 ? 'VALIDATION_ERROR' : 'SERVER_ERROR');
        throw flowError(code, stage, data.msg || data.message || '', { status });
      }
      return data;
    } catch (e) {
      if (e.name === 'KBFlowError') throw e;
      throw flowError(controller.signal.aborted ? 'TIMEOUT' : 'NETWORK', stage);
    } finally { clearTimeout(timer); }
  }

  function flowDeadline(promise, milliseconds, stage) {
    let timer;
    return Promise.race([promise, new Promise((_, reject) => {
      timer = setTimeout(() => reject(flowError('TIMEOUT', stage)), milliseconds);
    })]).finally(() => clearTimeout(timer));
  }

  async function flowPngFromSvg(svg) {
    // The already-generated preview has outlined text and embedded materials: no font/logo/background downloads.
    const doc = new DOMParser().parseFromString(svg, 'image/svg+xml');
    if (doc.querySelector('parsererror')) throw flowError('INVALID_PREVIEW', 'png');
    const vb = (doc.documentElement.getAttribute('viewBox') || '').trim().split(/\s+/).map(Number);
    const ratio = vb.length === 4 && vb[2] > 0 && vb[3] > 0 ? vb[2] / vb[3] : 2;
    const width = 1200, height = Math.max(120, Math.min(1200, Math.round(width / ratio)));
    const url = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml' }));
    try {
      const image = new Image();
      const loaded = new Promise((resolve, reject) => { image.onload = resolve; image.onerror = () => reject(flowError('INVALID_PREVIEW', 'png')); });
      image.src = url;
      await flowDeadline(loaded, 1500, 'png');
      const canvas = document.createElement('canvas');
      canvas.width = width; canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(image, 0, 0, width, height);
      return await flowDeadline(new Promise((resolve, reject) => canvas.toBlob(blob => blob ? resolve(blob) : reject(flowError('INVALID_PREVIEW', 'png')), 'image/png')), 1500, 'png');
    } finally { URL.revokeObjectURL(url); }
  }

  function readFlowOperation() {
    if (flowOperation) return flowOperation;
    for (const storageName of ['localStorage', 'sessionStorage']) {
      try {
        const operation = JSON.parse(window[storageName].getItem(flowStorageKey) || 'null');
        if (operation && /^[a-zA-Z0-9_-]{32,96}$/.test(operation.saveKey || '') && typeof operation.fingerprint === 'string') {
          flowOperation = operation;
          break;
        }
      } catch (_) {}
    }
    return flowOperation;
  }

  function persistFlowOperation(operation) {
    flowOperation = operation;
    for (const storageName of ['localStorage', 'sessionStorage']) {
      try {
        if (operation) window[storageName].setItem(flowStorageKey, JSON.stringify(operation));
        else window[storageName].removeItem(flowStorageKey);
      } catch (_) {}
    }
  }

  function newFlowOperation(config, variantId) {
    const fingerprint = JSON.stringify([variantId, config]);
    const prior = readFlowOperation();
    if (prior && prior.fingerprint === fingerprint && prior.cartState !== 'done') return prior;
    const operation = {
      fingerprint, variantId: String(variantId), saveKey: randId('save_') + randId(''),
      requestId: randId('flow_'), cartAttempt: randId('cart_'), timestamp: Date.now(), cartState: 'idle'
    };
    persistFlowOperation(operation);
    return operation;
  }

  function flowPostCartDestination() {
    return '/pages/upotpunite-dom';
  }

  function flowCartFailure(code, operation, cause, check) {
    const original = operation.cartFailure || {};
    return flowError(code, 'cart', '', {
      original_code: original.code || cause && cause.code || 'UNEXPECTED',
      original_status: original.status || cause && cause.status || 0,
      cart_check: check
    });
  }

  function flowCartMatches(item, operation) {
    return String(item.variant_id || item.id) === String(operation.variantId) &&
      item.properties && item.properties._kb_add_attempt === operation.cartAttempt &&
      (!operation.design || String(item.properties._design_id || '') === String(operation.design.design_id));
  }

  async function checkFlowCart(operation, cartRoot) {
    const cart = await flowFetch(cartRoot + 'cart.js', { cache: 'no-store', credentials: 'same-origin' }, 'cart', 10000);
    if (!cart || !Array.isArray(cart.items)) throw flowError('INVALID_RESPONSE', 'cart');
    // Aggregate discount-split lines; one variant can have other personalized lines.
    const items = cart.items.filter(item => flowCartMatches(item, operation));
    if (!items.length) return null;
    if (items.some(item => !Number.isInteger(Number(item.quantity)) || Number(item.quantity) < 1)) {
      throw flowError('INVALID_RESPONSE', 'cart');
    }
    return { items, quantity: items.reduce((total, item) => total + Number(item.quantity || 0), 0) };
  }

  async function confirmFlowCart(operation, existing, cartRoot, persist) {
    const wanted = Number(operation.quantity);
    if (!Number.isInteger(wanted) || wanted < 1) throw flowError('INVALID_RESPONSE', 'cart');
    const corrected = existing.quantity > wanted;
    if (existing.quantity < wanted) {
      operation.cartState = 'partial'; persist(operation);
      throw flowCartFailure('CART_PARTIAL', operation, null, 'partial');
    }
    if (existing.quantity > wanted) {
      // Set absolute quantities by current line key, preserving unrelated items.
      // Re-read after each mutation: discounts can change line keys.
      for (let step = 0; step < 8 && existing && existing.quantity > wanted; step++) {
        const extra = existing.quantity - wanted;
        const item = existing.items[existing.items.length - 1];
        if (!item.key) throw flowError('INVALID_RESPONSE', 'cart');
        await flowFetch(cartRoot + 'cart/change.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: Math.max(0, Number(item.quantity) - extra) })
        }, 'cart', 18000);
        existing = await checkFlowCart(operation, cartRoot);
      }
      if (!existing || existing.quantity !== wanted) {
        operation.cartState = 'unknown'; persist(operation);
        throw flowCartFailure('CART_UNKNOWN', operation, null, 'normalization_unconfirmed');
      }
    }
    operation.cartState = 'done'; persist(operation);
    return { recovered: true, corrected };
  }

  async function submitFlowCart(operation, payload, cartRoot, persist) {
    const execute = async (locked) => {
      // Another tab may have completed the same operation while this tab was stale.
      try {
        const shared = JSON.parse(window.localStorage.getItem(flowStorageKey) || 'null');
        if (shared && shared.cartAttempt === operation.cartAttempt) Object.assign(operation, shared);
      } catch (_) {}
      const wasDispatched = ['dispatched', 'unknown', 'partial', 'done'].includes(operation.cartState);
      if (wasDispatched) {
        let existing;
        try { existing = await checkFlowCart(operation, cartRoot); }
        catch (error) { throw flowCartFailure('CART_UNKNOWN', operation, error, 'failed'); }
        if (existing) return confirmFlowCart(operation, existing, cartRoot, persist);
        if (operation.cartState === 'done') throw flowCartFailure('CART_UNKNOWN', operation, null, 'removed');
        // No automatic replay. Recovery dispatch is permitted only from this
        // explicit user action with a valid complete payload and cross-tab lock.
        if (!locked || !payload.id || !payload.properties ||
            payload.properties._kb_add_attempt !== operation.cartAttempt ||
            Number(payload.id) !== Number(operation.variantId) ||
            Number(payload.quantity) !== Number(operation.quantity)) {
          throw flowCartFailure('CART_UNKNOWN', operation, null, 'empty_no_retry');
        }
        const dispatchedAt = Number(operation.cartDispatchedAt || operation.timestamp || Date.now());
        if (Date.now() - dispatchedAt < 30000) {
          throw flowCartFailure('CART_WAIT', operation, null, 'empty_wait');
        }
        // A separate fresh read guards an item appearing since the first read.
        await new Promise(resolve => setTimeout(resolve, 1200));
        try { existing = await checkFlowCart(operation, cartRoot); }
        catch (error) { throw flowCartFailure('CART_UNKNOWN', operation, error, 'failed'); }
        if (existing) return confirmFlowCart(operation, existing, cartRoot, persist);
      }
      if (!payload.id || !payload.properties || !Number.isInteger(payload.quantity) || payload.quantity < 1) {
        throw flowError('VALIDATION_ERROR', 'cart');
      }
      operation.cartState = 'dispatched';
      operation.quantity = payload.quantity;
      operation.cartDispatchedAt = Date.now();
      persist(operation);
      try {
        const result = await flowFetch(cartRoot + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        }, 'cart', 40000);
        const lines = result && Array.isArray(result.items) ? result.items : result ? [result] : [];
        if (!lines.some(item => flowCartMatches(item, operation))) throw flowError('INVALID_RESPONSE', 'cart');
        const existing = await checkFlowCart(operation, cartRoot);
        if (!existing) throw flowError('INVALID_RESPONSE', 'cart');
        const confirmed = await confirmFlowCart(operation, existing, cartRoot, persist);
        return { recovered: wasDispatched || confirmed.corrected === true };
      } catch (error) {
        operation.cartFailure = {
          code: /^[A-Z_]{1,50}$/.test(error.code || '') ? error.code : 'UNEXPECTED',
          status: Number(error.status) || 0
        };
        let existing, checkFailed = false;
        try { existing = await checkFlowCart(operation, cartRoot); } catch (_) { checkFailed = true; }
        if (existing) {
          try { return await confirmFlowCart(operation, existing, cartRoot, persist); }
          catch (confirmError) { persist(operation); throw confirmError; }
        }
        const rejected = [400, 403, 404, 413, 422, 429].includes(error.status);
        operation.cartState = rejected ? 'idle' : 'unknown'; persist(operation);
        if (rejected) throw error;
        throw flowCartFailure('CART_UNKNOWN', operation, error, checkFailed ? 'failed' : 'empty');
      }
    };
    const locks = window.navigator && window.navigator.locks;
    if (locks && typeof locks.request === 'function') {
      return locks.request('kb-design-cart', { ifAvailable: true }, lock => {
        if (!lock) throw flowError('CART_BUSY', 'cart');
        return execute(true);
      });
    }
    return execute(false);
  }


  function reportFlowOutcome(type, error, operation) {
    // Diagnostics contain no names, phone numbers, design contents or private save capability.
    const throttleKey = [type, error.stage || flowStage, error.code || 'UNEXPECTED', operation && operation.requestId || ''].join('|');
    const now = Date.now();
    if (now - (flowDiagnosticTimes.get(throttleKey) || 0) < 10000) return;
    if (flowDiagnosticTimes.size > 60) flowDiagnosticTimes.clear();
    flowDiagnosticTimes.set(throttleKey, now);
    void postLeadEvent(type, {
      stage: error.stage || flowStage, code: error.code || 'UNEXPECTED', status: error.status || 0,
      request_id: operation && operation.requestId || '', product_handle: cfg.productHandle || '',
      elapsed_ms: operation ? Math.max(0, Date.now() - operation.timestamp) : 0,
      original_code: /^[A-Z_]{1,50}$/.test(error.original_code || '') ? error.original_code : '',
      original_status: Number(error.original_status) || 0,
      cart_check: /^[a-z_]{1,40}$/.test(error.cart_check || '') ? error.cart_check : ''
    });
  }

  function showFlowError(error, saved = false, operation = null) {
    const view = flowErrorView(error, saved);
    setMessage(view.text, 'error');
    reportFlowOutcome('table_design_flow_error', error, operation);
    if (!message || view.action === 'none' || view.action === 'edit') return;
    flowAction = document.createElement('div');
    flowAction.className = 'kb-flow-actions';
    flowAction.style.cssText = 'display:flex;gap:10px;flex-wrap:wrap;margin:12px 0';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = addButton ? addButton.className : '';
    button.style.cssText = 'padding:12px 20px;min-height:44px;flex:1';
    button.textContent = view.action === 'cart' ? 'Proveri ponovo' : 'Pokušajte ponovo';
    button.addEventListener('click', () => {
      if (view.action === 'preview') { setMessage('Učitavam pregled…', 'loading'); renderPreview(); }
      else void addToCart();
    });
    flowAction.appendChild(button);
    if (view.action === 'cart') {
      const link = document.createElement('a');
      link.href = flowPostCartDestination();
      link.textContent = 'Nastavite kupovinu';
      link.style.cssText = 'display:flex;align-items:center;padding:12px;min-height:44px';
      flowAction.appendChild(link);
    }
    message.insertAdjacentElement('afterend', flowAction);
  }

  function completeFlowPreview(operation, design) {
    if (!design.preview_pending || !operation) return;
    try {
      const endpoint = new URL('complete_preview.php', cfg.saveUrl).href;
      void fetch(endpoint, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json',
        ...(cfg.ingestToken ? { 'X-Lead-Ingest-Token': cfg.ingestToken } : {}) },
        body: JSON.stringify({ idempotency_key: operation.saveKey }) }).catch(() => {});
    } catch (_) {}
  }
  // KB_FLOW_HELPERS_END


  function setMessage(text, state) {
    if (flowAction) { flowAction.remove(); flowAction = null; }
    if (message) { message.setAttribute("aria-live", "polite"); delete message.dataset.flowError; }

    if (!message) return;

    message.textContent = text || "";

    message.dataset.state = state || "";

  }



  function numberValidation(config) {
    if (!form) return { ok: true, message: "", input: null };
    const input = form.querySelector('[name="number"]');
    if (!input) return { ok: true, message: "", input: null };
    if (config && (isTextOnlyShape(config.shape) || (config.product_type === "apartment_plate" && cfg.apartmentNatpisOnly))) {
      return { ok: true, message: "", input };
    }
    const value = String(input.value || "").trim();
    const ok = !value || HOUSE_NUMBER_RE.test(value);
    return { ok, message: ok ? "" : HOUSE_NUMBER_MESSAGE, input };
  }

  function textFieldValidation(config) {
    const checks = [];
    const add = (name, value, requiredMessage) => {
      const input = form ? form.querySelector(`[name="${name}"]`) : null;
      const raw = String(value || "");
      const trimmed = raw.trim();
      if (requiredMessage && !trimmed) {
        checks.push({ ok: false, message: requiredMessage, input });
        return;
      }
      const bad = unsupportedEngravingChar(raw);
      checks.push({ ok: !bad, message: bad ? unsupportedCharMessage(bad) : "", input });
    };
    if (!config) return [{ ok: true, message: "", input: null }];
    if (config.product_type === "single_character") {
      const check = singleCharacterValidation(config.characters);
      checks.push({ ok: check.ok, message: check.ok ? "" : check.message, input: form ? form.querySelector('[name="characters"]') : null });
    } else if (config.product_type === "video_notice") {
      add("street", config.street, "Unesite gornji tekst.");
      add("extra_text", config.extra_text, "Unesite donji tekst.");
    } else if (config.product_type === "mailbox") {
      if (config.mailbox_top_text) add("extra_text", config.mailbox_top_text, "");
      add("street", config.mailbox_bottom_text, "Unesite donji tekst.");
    } else if (config.product_type === "parking_notice" || config.product_type === "dog_notice") {
      add("street", config.street, "Unesite natpis.");
    } else if (config.product_type === "apartment_plate" && cfg.apartmentNatpisOnly) {
      add("street", config.street, "Unesite natpis.");
    } else if (config.product_type === "apartment_plate" && config.shape === "stan_plocica") {
      const streetInput = form ? form.querySelector('[name="street"]') : null;
      const numberInput = form ? form.querySelector('[name="number"]') : null;
      if (!config.street && !config.number) {
        checks.push({ ok: false, message: "Unesite natpis ili broj.", input: streetInput || numberInput });
      }
      if (config.street) add("street", config.street, "");
    } else if (isNumberOnlyShape(config.shape)) {
      if (!config.number) checks.push({ ok: false, message: "Unesite broj.", input: form ? form.querySelector('[name="number"]') : null });
    } else {
      add("street", config.street, isStreetOptional(config) ? "" : "Unesite natpis.");
      if (!config.number) checks.push({ ok: false, message: "Unesite broj.", input: form ? form.querySelector('[name="number"]') : null });
    }
    return checks.length ? checks : [{ ok: true, message: "", input: null }];
  }

  function validateConfig(config) {
    const checks = [numberValidation(config), ...textFieldValidation(config)];
    return checks.find((check) => !check.ok) || { ok: true, message: "", input: null };
  }

  function syncValidationState(showMessage) {
    const result = validateConfig(currentConfig());
    const fields = form ? Array.from(form.querySelectorAll('[name="street"], [name="number"], [name="extra_text"], [name="characters"]')) : [];
    fields.forEach((input) => {
      const invalid = input === result.input && !result.ok;
      if (typeof input.setCustomValidity === "function") {
        input.setCustomValidity(invalid ? result.message : "");
      }
      input.toggleAttribute("aria-invalid", invalid);
    });
    root.querySelectorAll("[data-kb-add], [data-kb-mobile-add]").forEach((button) => {
      if (dodavanjeUToku) return;
      button.disabled = !result.ok;
      button.classList.toggle("is-disabled", !result.ok);
      button.setAttribute("aria-disabled", result.ok ? "false" : "true");
    });
    // Na poslednjem koraku dugme dodaje u korpu, pa mora da deli isto stanje sa [data-kb-add].
    const onFinalStep = mobileCartActionActive();
    root.querySelectorAll("[data-kb-step-next]").forEach((button) => {
      if (dodavanjeUToku) return;
      const blocked = onFinalStep && !result.ok;
      button.disabled = blocked;
      button.classList.toggle("is-disabled", blocked);
      button.setAttribute("aria-disabled", blocked ? "true" : "false");
    });
    if (showMessage) {
      if (!result.ok) setMessage(result.message, "error");
      else if (message && message.dataset.state === "error") setMessage("", "");
    }
    return result.ok;
  }


  function safeLocalStorageGet(key) {

    try {

      return window.localStorage ? localStorage.getItem(key) : "";

    } catch (err) {

      return "";

    }

  }



  function safeLocalStorageSet(key, value) {

    try {

      if (window.localStorage) {
        localStorage.setItem(key, String(value));
        return localStorage.getItem(key) === String(value);
      }

    } catch (err) {}

  }



  function safeLocalStorageRemove(key) {

    try {

      if (window.localStorage) localStorage.removeItem(key);

    } catch (err) {}

  }



  function randId(prefix) {

    const bytes = new Uint8Array(12);

    if (window.crypto && crypto.getRandomValues) {

      crypto.getRandomValues(bytes);

      return prefix + Array.from(bytes).map((b) => b.toString(16).padStart(2, "0")).join("");

    }

    return prefix + Math.random().toString(16).slice(2) + Date.now().toString(16);

  }



  function getAnonId() {

    let anonId = safeLocalStorageGet(LS_ANON_ID);

    if (!anonId) {

      anonId = randId("anon_");

      safeLocalStorageSet(LS_ANON_ID, anonId);

    }

    window.gsAnonId = anonId;

    return anonId;

  }



  function getSessionId() {

    const now = Date.now();

    const last = parseInt(safeLocalStorageGet(LS_LAST_ACTIVITY) || "0", 10);

    let sessionId = safeLocalStorageGet(LS_SESSION_ID);

    if (!sessionId || !last || now - last > SESSION_TIMEOUT_MS) {

      sessionId = randId("sess_");

    }

    safeLocalStorageSet(LS_SESSION_ID, sessionId);

    safeLocalStorageSet(LS_LAST_ACTIVITY, String(now));

    return sessionId;

  }



  function getLeadId() {

    const id = parseInt(safeLocalStorageGet(LS_LEAD_ID) || "", 10);

    return Number.isFinite(id) && id > 0 ? id : null;

  }



  function readCookie(name) {

    const prefix = name + "=";

    return String(document.cookie || "").split(";").map((part) => part.trim()).reduce((found, part) => {

      if (found) return found;

      return part.indexOf(prefix) === 0 ? decodeURIComponent(part.slice(prefix.length)) : "";

    }, "");

  }



  function queryParam(name) {

    try {

      return new URLSearchParams(window.location.search || "").get(name) || "";

    } catch (err) {

      return "";

    }

  }



  function metaIdentity() {

    const fbclid = queryParam("fbclid");

    let fbc = readCookie("_fbc");

    if (!fbc && fbclid) fbc = "fb.1." + Math.floor(Date.now() / 1000) + "." + fbclid;

    return {

      fbp: readCookie("_fbp"),

      fbc,

      fbclid,

      fb_login_id: facebookLoginId()

    };

  }



  function facebookLoginId() {

    try {

      if (window.KB_META_FB_LOGIN_ID) return String(window.KB_META_FB_LOGIN_ID || "");

      if (window.FB && typeof window.FB.getAuthResponse === "function") {

        const auth = window.FB.getAuthResponse();

        if (auth && auth.userID) return String(auth.userID || "");

      }

    } catch (err) {}

    return "";

  }



  function trackMetaLeadEvent(leadIdValue) {

    const id = parseInt(leadIdValue, 10);

    if (!id || typeof window.fbq !== "function") return;

    const eventId = "shopify_lead_" + id + "_lead";

    const key = LS_META_LEAD_EVENT_PREFIX + eventId;

    try {

      if (localStorage.getItem(key) === "1") return;

      window.fbq("track", "Lead", {}, { eventID: eventId });

      localStorage.setItem(key, "1");

    } catch (err) {}

  }



  function googleClientId() {

    const ga = readCookie("_ga");

    const match = /^GA\d+\.\d+\.(.+)$/.exec(ga);

    return match ? match[1] : "";

  }



  function googleSessionId() {

    const parts = String(document.cookie || "").split(";");

    for (const raw of parts) {

      const part = raw.trim();

      if (part.indexOf("_ga_") !== 0) continue;

      const value = decodeURIComponent(part.slice(part.indexOf("=") + 1));

      const match = /(?:^|\.)s(\d+)(?:\$|\.|$)/.exec(value) || /^GS\d+\.\d+\.(\d+)/.exec(value);

      if (match) return match[1];

    }

    return "";

  }



  function googleIdentity() {

    return {

      gclid: queryParam("gclid"),

      gbraid: queryParam("gbraid"),

      wbraid: queryParam("wbraid"),

      ga_client_id: googleClientId(),

      ga_session_id: googleSessionId()

    };

  }



  function visitorIdentity() {

    return {

      anon_id: getAnonId(),

      lead_id: getLeadId(),

      session_id: getSessionId()

    };

  }



  function crmDesignUrl(designId) {

    const id = String(designId || "").trim();

    return id ? CRM_EDITOR_BASE_URL + encodeURIComponent(id) : "";

  }



  function handleLeadResponse(res) {

    if (res && res.anon_id) {

      safeLocalStorageSet(LS_ANON_ID, res.anon_id);

      window.gsAnonId = res.anon_id;

    }

    if (res && res.lead_id) {

      const id = parseInt(res.lead_id, 10);

      if (Number.isFinite(id) && id > 0) {

        safeLocalStorageSet(LS_LEAD_ID, String(id));

        window.gsLeadId = id;

      }

    }

  }



  async function postLeadEvent(eventType, eventData) {
    eventData = eventData || {};
    if (!eventData.event_id) {
      eventData.event_id = "kb_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10);
    }
    // Use the existing allowlisted bridge: customer text stays out of GA4.
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      const analyticsAllowed = !privacy || typeof privacy.analyticsProcessingAllowed !== "function" ||
        privacy.analyticsProcessingAllowed();
      if (analyticsAllowed && typeof window.KB_GA4_TRACK_DESIGN_EVENT === "function") {
        window.KB_GA4_TRACK_DESIGN_EVENT(eventType, eventData);
      }
    } catch (err) { /* Analytics must never interrupt design or checkout. */ }
    if (!cfg.leadEventUrl) return visitorIdentity();

    const visitor = visitorIdentity();

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 2500);
    try {

      const response = await fetch(cfg.leadEventUrl, {

        method: "POST",
        signal: controller.signal,

        headers: { "Content-Type": "application/json" },

        body: JSON.stringify({

          anon_id: visitor.anon_id,

          lead_id: visitor.lead_id,

          session_id: visitor.session_id,

          event_type: eventType,

          event_data: eventData || {},

          page: window.location.href,

          referrer: document.referrer || "",

          ua: navigator.userAgent || "",

          meta: metaIdentity(),

          google: googleIdentity(),
          /* Ingest token: lead_event.php ga proverava i bez njega vraca 403.
             cfg.ingestToken dolazi iz Liquid-a i vec je postavljen na stranici —
             do 14.10.2026. koristio se samo za cuvanje dizajna, pa su se SVI
             dogadjaji konfiguratora gubili od 12.10. u 23:23. */
          ingest_token: cfg.ingestToken || ""

        })

      });

      const data = await response.json().catch(() => ({}));

      if (response.ok) handleLeadResponse(data);

    } catch (err) {} finally { clearTimeout(timeout); }

    return visitorIdentity();
  }

  function renderErrorPayload(error, config, context) {
    const cfgObj = config || {};
    const message = error && error.message ? String(error.message) : String(error || "Render greska");
    const textLengths = {
      street: String(cfgObj.street || "").length,
      number: String(cfgObj.number || "").length,
      extra_text: String(cfgObj.extra_text || "").length,
      characters: String(cfgObj.characters || "").length
    };
    return {
      context: context || "preview",
      message: message.slice(0, 220),
      name: error && error.name ? String(error.name).slice(0, 80) : "",
      product_handle: cfg.productHandle || "",
      product_id: cfg.productId || "",
      variant_id: selectedVariantId(),
      shape: cfgObj.shape || cfgObj.plate_shape || cfg.renderShape || "",
      product_type: cfgObj.product_type || "",
      dimensions: `${cfgObj.width_cm || ""}x${cfgObj.height_cm || ""}`,
      character_height_cm: cfgObj.character_height_cm || "",
      physical_character_count: cfgObj.physical_character_count || physicalCharacterCount(cfgObj.characters || ""),
      script: cfgObj.script || "",
      plocica_font: cfgObj.plocica_font || "",
      text_lengths: textLengths
    };
  }

  function sendRenderErrorBeacon(error, config, context) {
    if (!cfg.leadEventUrl) return;
    const payload = renderErrorPayload(error, config, context);
    const throttleKey = LS_RENDER_ERROR_PREFIX + [
      payload.context,
      payload.shape,
      payload.product_type,
      payload.message
    ].join("|").slice(0, 220);
    const now = Date.now();
    const last = parseInt(safeLocalStorageGet(throttleKey) || "0", 10);
    if (last && now - last < 30000) return;
    safeLocalStorageSet(throttleKey, String(now));
    const visitor = visitorIdentity();
    const body = JSON.stringify({
      anon_id: visitor.anon_id,
      lead_id: visitor.lead_id,
      session_id: visitor.session_id,
      event_type: "table_design_render_error",
      event_data: payload,
      page: window.location.href,
      referrer: document.referrer || "",
      ua: navigator.userAgent || "",
      meta: metaIdentity(),
      google: googleIdentity(),
      ingest_token: cfg.ingestToken || ""
    });
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(cfg.leadEventUrl, new Blob([body], { type: "text/plain;charset=UTF-8" }));
        return;
      }
    } catch (err) {}
    try {
      fetch(cfg.leadEventUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true
      }).catch(() => {});
    } catch (err) {}
  }

  function field(name) {
    const el = form ? form.querySelector(`[name="${name}"]`) : null;

    return el ? String(el.value || "").trim() : "";

  }



  function normalizeContactPhone(phone) {

    const raw = String(phone || "").replace(/\s+/g, " ").trim();

    const digits = raw.replace(/\D/g, "");

    if (digits.length < 8) return "";

    if (raw === "+381" || raw === "+381 ") return "";

    return raw;

  }



  function identifyContactPhoneNow(phone) {

    const normalized = normalizeContactPhone(phone);

    if (!normalized || normalized === lastIdentifiedContactPhone || typeof window.kbIdentifyLeadByPhone !== "function") {

      return Promise.resolve(visitorIdentity());

    }

    lastIdentifiedContactPhone = normalized;

    phoneIdentifyPromise = Promise.resolve(window.kbIdentifyLeadByPhone(normalized, "table_designer_phone"))

      .catch(() => null)

      .then((id) => {

        trackMetaLeadEvent(id || window.gsLeadId || getLeadId());

        return visitorIdentity();

      })

      .finally(() => {

        phoneIdentifyPromise = null;

      });

    return phoneIdentifyPromise;

  }



  function scheduleContactPhoneIdentify() {

    clearTimeout(contactPhoneTimer);

    const phone = field("contact_phone");

    if (!normalizeContactPhone(phone)) return;

    contactPhoneTimer = setTimeout(() => {

      identifyContactPhoneNow(phone);

    }, 900);

  }



  async function ensureContactPhoneIdentified(config) {

    const phone = config && config.contact_phone ? config.contact_phone : field("contact_phone");

    if (phoneIdentifyPromise) await phoneIdentifyPromise;

    await identifyContactPhoneNow(phone);

    if (phoneIdentifyPromise) await phoneIdentifyPromise;

    return visitorIdentity();

  }



  function setField(name, value) {

    if (!form || value == null || value === "") return;

    const el = form.querySelector(`[name="${name}"]`);

    if (!el) return;

    // Vrednost moze da stigne sa drugog proizvoda (prenos sa "Upotpunite dom").

    // Ako taj izbor ovde ne postoji, el.value bi postao prazan i obrisao

    // podrazumevani izbor — zato se takva vrednost preskace.

    if (el.tagName === "SELECT") {

      var postoji = Array.prototype.some.call(el.options, function (o) { return o.value === String(value); });

      if (!postoji) return;

    }

    el.value = String(value);

    el.dispatchEvent(new Event("change", { bubbles: true }));

  }



  const cyrToLatMap = {

    "\u0430": "a", "\u0431": "b", "\u0432": "v", "\u0433": "g", "\u0434": "d", "\u0452": "\u0111", "\u0435": "e",

    "\u0436": "\u017E", "\u0437": "z", "\u0438": "i", "\u0458": "j", "\u043A": "k", "\u043B": "l", "\u0459": "lj",

    "\u043C": "m", "\u043D": "n", "\u045A": "nj", "\u043E": "o", "\u043F": "p", "\u0440": "r", "\u0441": "s",

    "\u0442": "t", "\u045B": "\u0107", "\u0443": "u", "\u0444": "f", "\u0445": "h", "\u0446": "c", "\u0447": "\u010D",

    "\u045F": "d\u017E", "\u0448": "\u0161"

  };

  const latToCyrDigraphs = { "lj": "\u0459", "nj": "\u045A", "dj": "\u0452", "d\u017E": "\u045F", "dz\u030C": "\u045F" };

  const latToCyrMap = {

    "a": "\u0430", "b": "\u0431", "v": "\u0432", "g": "\u0433", "d": "\u0434", "\u0111": "\u0452", "e": "\u0435",

    "\u017E": "\u0436", "z": "\u0437", "i": "\u0438", "j": "\u0458", "k": "\u043A", "l": "\u043B", "m": "\u043C",

    "n": "\u043D", "o": "\u043E", "p": "\u043F", "r": "\u0440", "s": "\u0441", "t": "\u0442", "\u0107": "\u045B",

    "u": "\u0443", "f": "\u0444", "h": "\u0445", "c": "\u0446", "\u010D": "\u0447", "\u0161": "\u0448"

  };

function isUpper(ch) {

    return ch && ch !== ch.toLowerCase() && ch === ch.toUpperCase();

  }



  function applyCase(src, out, nextIsUpper, atEnd) {

    if (!isUpper(src)) return out;

    if (out.length === 1) return out.toUpperCase();

    if (nextIsUpper || atEnd) return out.toUpperCase();

    return out.charAt(0).toUpperCase() + out.slice(1);

  }



  function cyrToLat(text) {

    const source = String(text || "");

    let res = "";

    for (let i = 0; i < source.length; i++) {

      const ch = source[i];

      const mapped = cyrToLatMap[ch.toLowerCase()];

      if (mapped == null) {

        res += ch;

        continue;

      }

      const nextUpper = i + 1 < source.length && isUpper(source[i + 1]);

      const atEnd = i + 1 >= source.length;

      res += applyCase(ch, mapped, nextUpper, atEnd);

    }

    return res;

  }



  function latToCyr(text) {

    const source = String(text || "");

    /* q, w, x, y nemaju parnjak u cirilici. Ako ih ima, ostavi ceo tekst u
       latinici — mesano pismo na gravuri je gore nego latinica. */

    if (/[qwxy]/i.test(source)) return source;

    let res = "";

    let i = 0;

    while (i < source.length) {

      const three = source.substr(i, 3).toLowerCase();

      const two = source.substr(i, 2).toLowerCase();

      const digraph = latToCyrDigraphs[three] || latToCyrDigraphs[two];

      if (digraph) {

        const used = latToCyrDigraphs[three] ? 3 : 2;

        const firstUpper = isUpper(source[i]);

        const secondUpper = isUpper(source[i + 1]);

        res += firstUpper && secondUpper ? digraph.toUpperCase() : (firstUpper ? digraph.toUpperCase() : digraph);

        i += used;

        continue;

      }

      const ch = source[i];

      const mapped = latToCyrMap[ch.toLowerCase()];

      if (mapped == null) {

        res += ch;

        i++;

        continue;

      }

      res += isUpper(ch) ? mapped.toUpperCase() : mapped;

      i++;

    }

    return res;

  }



  function scriptValue() {

    return field("script") || "cyrillic";

  }



  function textFields() {

    return form ? Array.from(form.querySelectorAll('[name="street"], [name="number"], [name="extra_text"], [name="characters"]')) : [];

  }



  function transliterateValue(value, targetScript) {

    if (targetScript === "cyrillic") return latToCyr(value);

    if (targetScript === "latin") return cyrToLat(value);

    return value;

  }



  function transliterateField(input, targetScript) {

    if (!input || !isTextEntryField(input)) return false;

    const next = transliterateValue(input.value, targetScript);

    if (next === input.value) return false;

    input.value = next;

    const pos = input.value.length;

    if (document.activeElement === input && typeof input.setSelectionRange === "function") {

      input.setSelectionRange(pos, pos);

    }

    return true;

  }



  function transliterateAllFields() {

    const target = scriptValue();

    if (target !== "cyrillic" && target !== "latin") return;

    let changed = false;

    textFields().forEach((input) => {

      changed = transliterateField(input, target) || changed;

    });

    if (changed) schedulePreview();

  }



  function scheduleFieldTransliteration(input) {

    const target = scriptValue();

    if (target !== "cyrillic" && target !== "latin") return;

    clearTimeout(transliterationTimers.get(input));

    transliterationTimers.set(input, setTimeout(() => {

      if (transliterateField(input, target)) schedulePreview();

    }, 260));

  }



  function selectedVariantId() {

    if (variantInput && variantInput.value) return String(variantInput.value);

    const urlVariant = new URLSearchParams(window.location.search).get("variant");

    if (urlVariant) return String(urlVariant);

    return String(cfg.variantId || "");

  }



  function selectedOptionValues() {

    const values = [];

    const optionInputs = document.querySelectorAll('variant-selects select, variant-radios input[type="radio"]:checked, .product-form__input input[type="radio"]:checked, .product-form__input select');

    optionInputs.forEach((el) => {

      if (el.name === "id" || el.disabled) return;

      const value = String(el.value || "").trim();

      if (value && !values.includes(value)) values.push(value);

    });

    return values;

  }



  function selectedVariant() {

    const id = selectedVariantId();

    const variants = Array.isArray(cfg.variants) ? cfg.variants : [];

    const byId = variants.find((v) => String(v.id) === id);

    if (byId) return byId;

    const selectedOptions = selectedOptionValues();

    const byOptions = selectedOptions.length ? variants.find((variant) => {

      const options = Array.isArray(variant.options) ? variant.options.map(String) : [];

      return selectedOptions.every((value) => options.includes(value));

    }) : null;

    return byOptions || { id, title: cfg.variantTitle || "", options: [] };

  }



  function formatMoney(cents) {

    const amount = Number(cents);

    if (!Number.isFinite(amount)) return "";

    if (window.Shopify && typeof Shopify.formatMoney === "function") {

      return Shopify.formatMoney(amount, window.theme && theme.moneyFormat ? theme.moneyFormat : undefined).replace(/<[^>]+>/g, "");

    }

    return new Intl.NumberFormat("sr-RS", {

      style: "currency",

      currency: "RSD",

      maximumFractionDigits: 0

    }).format(amount / 100);

  }



  function updatePrice() {

    const variant = selectedVariant();

    const shape = cfg.renderShape || root.dataset.renderShape || "standard";

    if (isSingleCharacterShape(shape)) {

      const check = singleCharacterValidation(field("characters"));

      const count = check.ok ? check.count : 0;

      if (customDimActive || isCustomCharacterHeightVariant(variant)) {

        priceNodes.forEach((node) => {

          node.textContent = count ? `Cena će biti potvrđena nakon porudžbine · ${count} kom.` : "Cena će biti potvrđena nakon porudžbine";

        });

        return;

      }

      const unit = variant && variant.price != null ? Number(variant.price) : 0;

      priceNodes.forEach((node) => {

        node.textContent = count && unit ? `${formatMoney(unit * count)} (${count} x ${formatMoney(unit)})` : (unit ? formatMoney(unit) : "");

      });

      return;

    }

    if (customDimActive || isCustomDimVariant(variant)) {

      priceNodes.forEach((node) => {

        node.textContent = "Cena se prosleđuje nakon porudžbine";

      });

      return;

    }

    const price = variant && variant.price != null ? formatMoney(variant.price) : "";

    priceNodes.forEach((node) => {

      node.textContent = price || "";

    });

  }



  function parseDimension(value) {

    const text = String(value || "").replace(",", ".");

    const match = text.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);

    if (!match) return { width_cm: null, height_cm: null, ratio_label: "" };

    const width = Number(match[1]);

    const height = Number(match[2]);

    return {

      width_cm: Number.isFinite(width) ? width : null,

      height_cm: Number.isFinite(height) ? height : null,

      ratio_label: width && height ? `${width}:${height}` : ""

    };

  }



  function normalizedNumber(value) {

    const n = Number(String(value || "").replace(",", "."));

    return Number.isFinite(n) ? Math.round(n * 100) / 100 : null;

  }



  function parseCharacterHeight(value) {

    const text = String(value || "").replace(",", ".");

    const match = text.match(/(\d+(?:\.\d+)?)\s*cm/i);

    if (!match) return null;

    const h = Number(match[1]);

    return Number.isFinite(h) && h > 0 ? Math.round(h * 100) / 100 : null;

  }



  function selectedCharacterHeightVariant() {

    const variant = selectedVariant();

    const parts = [variant.title || cfg.variantTitle || ""].concat(Array.isArray(variant.options) ? variant.options : []);

    for (const part of parts) {

      const height = parseCharacterHeight(part);

      if (height) return { variant, height_cm: height, custom: false };

    }

    return { variant, height_cm: normalizedNumber(customHeightInput && customHeightInput.value) || 20, custom: true };

  }



  function isCustomCharacterHeightVariant(variant) {

    if (!variant) return false;

    const parts = [variant.title || ""].concat(Array.isArray(variant.options) ? variant.options : []);

    return !parts.some((part) => parseCharacterHeight(part));

  }



  function sameDimension(a, b) {

    return normalizedNumber(a && a.width_cm) === normalizedNumber(b && b.width_cm)

      && normalizedNumber(a && a.height_cm) === normalizedNumber(b && b.height_cm);

  }



  function preferredDefaultDimension() {

    const shape = cfg.renderShape || root.dataset.renderShape || "standard";

    if (shape === "plocica_oblik_1") return { width_cm: 12, height_cm: 5 };

    if (shape === "stan_plocica" || shape === "plocica_oblik_2" || shape === "plocica_oblik_4") return { width_cm: 15, height_cm: 4 };

    const ratio = String(cfg.renderRatio || root.dataset.renderRatio || "");

    if (ratio === "1:1") return { width_cm: 20, height_cm: 20 };

    if (ratio === "3:2") return { width_cm: 30, height_cm: 20 };

    return { width_cm: 40, height_cm: 20 };

  }



  function isPreferredDefaultDimension(dims) {

    return sameDimension(dims, preferredDefaultDimension());

  }



  function displayCm(value) {

    const n = normalizedNumber(value);

    if (n == null) return "";

    return String(n).replace(".", ",");

  }



  function ratioSlug() {

    const ratio = String(cfg.renderRatio || root.dataset.renderRatio || "2:1");

    if (ratio === "1:1") return "1-1";

    if (ratio === "3:2") return "3-2";

    return "2-1";

  }



  function ratioFallbackDimension(ratio) {

    const label = String(ratio || cfg.renderRatio || root.dataset.renderRatio || "");

    /* Oblik ima prednost nad odnosom. Za plocice je renderRatio namerno "2:1" (korpa za

       renderovanje, koristi je ratioSlug za imena asseta), pa bi se ovde bez provere

       vratilo 40x20 umesto 15x4 — i varijanta "po meri" bi lazno prijavila 40x20.

       Isti redosled vec koristi preferredDefaultDimension(). QA 02.11.2026. */

    const shapeFb = cfg.renderShape || root.dataset.renderShape || "standard";

    if (shapeFb === "plocica_oblik_1") return { width_cm: 12, height_cm: 5, ratio_label: label };

    if (shapeFb === "stan_plocica" || shapeFb === "plocica_oblik_2" || shapeFb === "plocica_oblik_4") return { width_cm: 15, height_cm: 4, ratio_label: label };

    if (label === "1:1") return { width_cm: 30, height_cm: 30, ratio_label: "1:1" };

    if (label === "3:2") return { width_cm: 40, height_cm: 25, ratio_label: "3:2" };

    return { width_cm: 40, height_cm: 20, ratio_label: "2:1" };

  }



  function currentDimension(variant) {

    const parts = [variant.title || cfg.variantTitle || ""].concat(Array.isArray(variant.options) ? variant.options : []);

    for (const part of parts) {

      const parsed = parseDimension(part);

      if (parsed.width_cm && parsed.height_cm) return parsed;

    }

    return ratioFallbackDimension(cfg.renderRatio || root.dataset.renderRatio);

  }



  function dimensionLabel(dims) {

    if (dims && !dims.width_cm && dims.height_cm && dims.ratio_label === "character-height") return `${displayCm(dims.height_cm)} cm`;

    return dims && dims.width_cm && dims.height_cm ? `${displayCm(dims.width_cm)} x ${displayCm(dims.height_cm)} cm` : "";

  }



  // A variant whose title/options do NOT contain a parseable WxH (e.g.

  // "Neka druga dimenzija") is the custom-dimension / quote variant.

  function isCustomDimVariant(variant) {

    if (!variant) return false;

    const parts = [variant.title || ""].concat(Array.isArray(variant.options) ? variant.options : []);

    return !parts.some((p) => {

      const d = parseDimension(p);

      return d.width_cm && d.height_cm;

    });

  }

  function customDimVariant() {

    const variants = Array.isArray(cfg.variants) ? cfg.variants : [];

    const shape = cfg.renderShape || root.dataset.renderShape || "standard";

    if (isSingleCharacterShape(shape)) return variants.find(isCustomCharacterHeightVariant) || null;

    return variants.find(isCustomDimVariant) || null;

  }

  function customDims() {

    const w = normalizedNumber(customWidthInput && customWidthInput.value);

    const h = normalizedNumber(customHeightInput && customHeightInput.value);

    if (!w || !h) return null;

    return { width_cm: w, height_cm: h, ratio_label: `${w}:${h}` };

  }



  function productDimensionOptions() {

    const shape = cfg.renderShape || root.dataset.renderShape || "standard";

    if (isSingleCharacterShape(shape)) {

      const seenHeights = new Set();

      const variants = Array.isArray(cfg.variants) ? cfg.variants : [];

      return variants.map((variant) => {

        if (isCustomCharacterHeightVariant(variant)) return null;

        const height = parseCharacterHeight(variant.title || (Array.isArray(variant.options) ? variant.options.join(" ") : ""));

        if (!height || seenHeights.has(height)) return null;

        seenHeights.add(height);

        return {

          id: variant.id,

          width_cm: 0,

          height_cm: height,

          label: `${displayCm(height)} cm`,

          recommended: height === 20,

          price: variant.price != null ? formatMoney(variant.price) : ""

        };

      }).filter(Boolean);

    }

    const seen = new Set();

    const variants = Array.isArray(cfg.variants) ? cfg.variants : [];

    return variants.map((variant) => {

      if (isCustomDimVariant(variant)) return null;

      const dims = currentDimension(variant);

      const key = `${normalizedNumber(dims.width_cm)}x${normalizedNumber(dims.height_cm)}`;

      if (!dims.width_cm || !dims.height_cm || seen.has(key)) return null;

      seen.add(key);

      return {

        id: variant.id,

        width_cm: dims.width_cm,

        height_cm: dims.height_cm,

        label: dimensionLabel(dims),

        recommended: isPreferredDefaultDimension(dims),

        price: variant.price != null ? formatMoney(variant.price) : ""

      };

    }).filter(Boolean);

  }



  function renderDimensionOptions() {

    if (!dimensionOptions) return;

    const options = productDimensionOptions();

    if (!options.length) {

      var kbPfH = dimensionOptions.closest(".kb-product-fields"); if (kbPfH) kbPfH.setAttribute("hidden", "");

      return;

    }

    var kbPfS = dimensionOptions.closest(".kb-product-fields"); if (kbPfS) kbPfS.removeAttribute("hidden");

    let html = options.map((item) => `

      <button

        type="button"

        class="kb-dimension-option"

        data-kb-dimension-choice

        data-kb-dimension-width="${escapeHtml(item.width_cm)}"

        data-kb-dimension-height="${escapeHtml(item.height_cm)}"

        aria-pressed="false"

      >

        ${escapeHtml(item.label)}

        ${item.recommended ? '<span class="kb-dimension-option__hint">Najčešće odabrana</span>' : ""}

        ${item.price ? `<small>${escapeHtml(item.price)}</small>` : ""}

      </button>

    `).join("");

    if (customDimVariant()) {

      const shape = cfg.renderShape || root.dataset.renderShape || "standard";

      const customLabel = isSingleCharacterShape(shape) ? "Neka druga visina" : "Neka druga dimenzija";

      html += `

      <button

        type="button"

        class="kb-dimension-option"

        data-kb-dimension-custom

        aria-pressed="false"

      >

        ${customLabel}

        <small>Cena nakon porudžbine</small>

      </button>`;

    }

    dimensionOptions.innerHTML = html;

  }



  function updateDimensionControls() {

    const variant = selectedVariant();

    const shape = cfg.renderShape || root.dataset.renderShape || "standard";

    const charHeight = isSingleCharacterShape(shape) ? selectedCharacterHeightVariant() : null;

    const dims = charHeight

      ? { width_cm: 0, height_cm: charHeight.height_cm, ratio_label: "character-height" }

      : ((customDimActive && customDims()) ? customDims() : currentDimension(variant));

    if (selectedDimensionLabel) selectedDimensionLabel.textContent = dimensionLabel(dims);

    if (shapeCurrentLabel) shapeCurrentLabel.textContent = shapeLabels[cfg.renderShape || root.dataset.renderShape || "standard"] || "Oblik";

    if (!dimensionOptions) return;

    dimensionOptions.querySelectorAll("[data-kb-dimension-choice]").forEach((button) => {

      const buttonDims = {

        width_cm: button.dataset.kbDimensionWidth,

        height_cm: button.dataset.kbDimensionHeight

      };

      const pressed = charHeight

        ? (!customDimActive && normalizedNumber(charHeight.height_cm) === normalizedNumber(buttonDims.height_cm))

        : (!customDimActive && sameDimension(dims, buttonDims));

      button.setAttribute("aria-pressed", pressed ? "true" : "false");

    });

    const customBtn = dimensionOptions.querySelector("[data-kb-dimension-custom]");

    if (customBtn) customBtn.setAttribute("aria-pressed", customDimActive ? "true" : "false");

  }



  function currentConfig() {

    const variant = selectedVariant();

    const dims = (customDimActive && customDims()) ? customDims() : currentDimension(variant);

    const shape = cfg.renderShape || root.dataset.renderShape || "standard";

    const isApartmentPlate = isApartmentPlateShape(shape);

    const isVideoNotice = shape === "video_nadzor";

    const isParkingNotice = shape === "zabranjeno_parkiranje";

    const isDogNotice = shape === "cuvaj_se_psa";

    const isMailbox = shape === "postansko_sanduce";

    const isSingleCharacters = isSingleCharacterShape(shape);

    const numberOnlyShape = isNumberOnlyShape(shape);

    const numberAlign = centerNumberShapes.has(shape) && field("number_align") === "center" ? "center" : "right";

    const street = numberOnlyShape ? "" : field("street");

    const extraText = (numberOnlyShape || shape === "oblik_4_retro") ? "" : field("extra_text");

    const mailboxTopText = isMailbox ? extraText : "";

    const mailboxBottomText = isMailbox ? street : "";

    const note = field("note");

    const contactPhone = normalizeContactPhone(field("contact_phone"));

    const characterHeight = isSingleCharacters ? selectedCharacterHeightVariant() : null;

    const characters = isSingleCharacters ? field("characters") : "";

    const characterCheck = isSingleCharacters ? singleCharacterValidation(characters) : null;

    const engravingColor = isApartmentPlate ? field("engraving_color") || "srebrna_graverska" : "";

    const plateStyle = isApartmentPlate && shape === "stan_plocica" && cfg.apartmentNatpisOnly && field("plate_style") === "rounded" ? "rounded" : "rectangular";

    const plateColor = isApartmentPlate ? engravingColor : (field("plate_color") || field("background_color") || "crna");

    const textColor = isApartmentPlate ? (engravingColor === "crna_graverska" ? "bela" : "crna") : (isMailbox && MAILBOX_MIRROR_PLATE_COLORS.has(plateColor) ? "siva" : field("text_color"));

    const productType = isApartmentPlate ? "apartment_plate" : (isVideoNotice ? "video_notice" : (isParkingNotice ? "parking_notice" : (isDogNotice ? "dog_notice" : (isMailbox ? "mailbox" : (isSingleCharacters ? "single_character" : "house_number")))));

    return {

      plate_shape: shape,
      ...(shape === "oblik_4_retro" ? { retro_frame_version: 2 } : {}),

      shape,

      product_type: productType,

      ratio_label: isMailbox ? "mailbox" : (cfg.renderRatio || root.dataset.renderRatio || dims.ratio_label),

      width_cm: isMailbox ? 19.4 : (isSingleCharacters ? 0 : dims.width_cm),

      height_cm: isMailbox ? 29.6 : (isSingleCharacters ? characterHeight.height_cm : dims.height_cm),

      character_height_cm: isSingleCharacters ? characterHeight.height_cm : null,

      custom_height: isSingleCharacters ? characterHeight.custom : false,

      characters: isSingleCharacters ? characters.toUpperCase() : "",

      physical_character_count: isSingleCharacters && characterCheck && characterCheck.ok ? characterCheck.count : 0,

      number: (isTextOnlyShape(shape) || (isApartmentPlate && cfg.apartmentNatpisOnly)) ? "" : field("number").toUpperCase(),

      street: isApartmentPlate ? street : street.toUpperCase(),

      extra_text: isApartmentPlate ? extraText : extraText.toUpperCase(),

      mailbox_top_text: isMailbox ? mailboxTopText.toUpperCase() : "",

      mailbox_bottom_text: isMailbox ? mailboxBottomText.toUpperCase() : "",

      mailbox_has_top_plate: isMailbox ? !!mailboxTopText : false,

      mailbox_door_color: isMailbox ? (field("mailbox_door_color") || "drvo_dezen") : "",

      mailbox_side_color: isMailbox ? (field("mailbox_side_color") || "cesljano_srebro") : "",

      dog_symbol_key: isDogNotice ? (field("dog_symbol_key") || "lovacki_01") : "",

      note,

      contact_phone: contactPhone,

      plate_color: plateColor,

      background_color: plateColor,

      text_color: textColor || "srebrno_ogledalo",

      engraving_color: engravingColor,

      plate_style: plateStyle,

      distancer_color: (isApartmentPlate || isMailbox) ? "" : (field("distancer_color") || (textColor.indexOf("zlatno_ogledalo") === 0 ? "zlatna" : "srebrna")),

      script: scriptValue(),

      number_align: numberAlign,

      text_case: field("text_case") || "uppercase",

      plocica_font: (isApartmentPlate || isSingleCharacters) ? (field("plocica_font") || "") : ""

    };

  }



  function draftStorageKey() {

    const productKey = cfg.productHandle || cfg.productId || root.dataset.renderShape || "unknown";

    return LS_DESIGN_DRAFT_PREFIX + String(productKey);

  }



  function designTextGroup(config) {

    const productType = config && config.product_type ? String(config.product_type) : "";

    if (productType === "house_number") return "house_number";

    if (productType === "apartment_plate") return "apartment_plate";

    if (productType === "mailbox") return "mailbox";

    if (productType === "single_character") return "single_character";

    return "";

  }



  function lastTextStorageKey(group) {

    return group ? LS_DESIGN_TEXT_PREFIX + group : "";

  }



  function draftPrimaryText(config) {

    return [

      config.street,

      config.number,

      config.extra_text,

      config.characters,

      config.mailbox_top_text,

      config.mailbox_bottom_text,

      config.note,

      config.contact_phone

    ].filter(Boolean).join(" ").trim();

  }



  function hasMeaningfulDraft(config) {

    if (!config) return false;

    if (draftPrimaryText(config)) return true;

    if (config.dog_symbol_key && config.dog_symbol_key !== "lovacki_01") return true;

    if (config.number_align && config.number_align !== "right") return true;

    if (config.plate_style && config.plate_style !== "rectangular") return true;

    return false;

  }



  function setFieldValue(name, value) {

    if (!form || value == null) return;

    const el = form.querySelector(`[name="${name}"]`);

    if (!el) return;

    el.value = String(value);

    el.dispatchEvent(new Event("change", { bubbles: true }));

  }



  function applyDraftConfig(config, preserveVariant = false) {

    if (!config || !form) return false;

    restoringDraft = true;

    [

      "street",

      "number",

      "extra_text",

      "characters",

      "note",

      "contact_phone",

      "script",

      "plate_color",

      "background_color",

      "text_color",

      "distancer_color",

      "engraving_color",

      "number_align",

      "dog_symbol_key",

      "mailbox_door_color",

      "mailbox_side_color",

      "plate_style",

      "text_case",

      "plocica_font"

    ].forEach((name) => setFieldValue(name, config[name]));

    if (!preserveVariant && config.product_type === "single_character" && config.character_height_cm) {

      selectVariantByCharacterHeight(config.character_height_cm);

    } else if (!preserveVariant && config.width_cm && config.height_cm) {

      selectVariantByDimension(config.width_cm, config.height_cm);

    }

    syncDistancerDefault();

    updateSwatches();

    updateFontSamples();

    restoringDraft = false;
    if (primaryTextBaseline !== null) resetPrimaryTextMeasurement(currentConfig());

    return true;

  }



  function readLastTextForCurrentProduct() {

    const group = designTextGroup(currentConfig());

    const key = lastTextStorageKey(group);

    if (!key) return null;

    const raw = safeLocalStorageGet(key);

    if (!raw) return null;

    try {

      const parsed = JSON.parse(raw);

      return parsed && parsed.text ? parsed : null;

    } catch (err) {

      safeLocalStorageRemove(key);

      return null;

    }

  }



  function applyLastTextForRelatedProduct() {

    if (readLocalDraft() || !form) return false;

    const lastText = readLastTextForCurrentProduct();

    const text = lastText && lastText.text;

    if (!text) return false;

    // Ranije se gledalo "ima li teksta u poljima", ali tu UVEK stoji podrazumevani
    // tekst iz Liquid-a (npr. "ВОЈВОЂАНСКА 23"), pa se prenos unosa nikad nije desio.
    // Sada preuzimamo samo ako je na stranici jos uvek netaknuto podrazumevano stanje.
    if (pristinePrimaryText === null) {
      try { pristinePrimaryText = draftPrimaryText(currentConfig()); } catch (e) { pristinePrimaryText = ""; }
    }

    if (draftDiffersFromPristine(currentConfig())) return false;



    restoringDraft = true;

    ["street", "number", "extra_text", "characters", "contact_phone"].forEach((name) => {

      if (text[name]) setFieldValue(name, text[name]);

    });

    restoringDraft = false;

    if (!relatedPrefillReported) {

      relatedPrefillReported = true;

      postLeadEvent("table_design_related_prefill_used", {

        source_product_handle: lastText.product_handle || "",

        target_product_handle: cfg.productHandle || "",

        group: lastText.group || designTextGroup(currentConfig()),

        has_street: !!text.street,

        has_number: !!text.number,

        has_extra_text: !!text.extra_text,

        has_characters: !!text.characters,

        has_contact_phone: !!text.contact_phone

      }).catch(() => {});

    }

    return true;

  }



  function readLocalDraft() {

    const raw = safeLocalStorageGet(draftStorageKey());

    if (!raw) return null;

    try {

      return JSON.parse(raw);

    } catch (err) {

      safeLocalStorageRemove(draftStorageKey());

      return null;

    }

  }



  // Konfigurator snimi nacrt i sa PODRAZUMEVANIM vrednostima (npr. "23" /
  // "VOJVODJANSKA"), pa je dugme pisalo "Nastavi unos" i kupcu koji nista nije
  // uneo. Zato pamtimo netaknuto stanje i trazimo stvarnu razliku.
  // Prvi poziv ove funkcije desava se PRE restoreLocalDraft() u inicijalizaciji,
  // pa tada u DOM-u jos stoje podrazumevane vrednosti iz Liquid-a.
  let pristinePrimaryText = null;

  function draftDiffersFromPristine(config) {

    if (!config) return false;

    if (pristinePrimaryText !== null && draftPrimaryText(config) !== pristinePrimaryText) return true;

    if (config.dog_symbol_key && config.dog_symbol_key !== "lovacki_01") return true;

    if (config.number_align && config.number_align !== "right") return true;

    if (config.plate_style && config.plate_style !== "rectangular") return true;

    return false;

  }

  function updateMobileOpenButtonLabel() {

    if (!mobileOpenButton) return;

    if (pristinePrimaryText === null) {

      try { pristinePrimaryText = draftPrimaryText(currentConfig()); } catch (e) { pristinePrimaryText = ""; }

    }

    const draft = readLocalDraft();

    const resumable = draft && hasMeaningfulDraft(draft.config) && draftDiffersFromPristine(draft.config);

    mobileOpenButton.textContent = resumable

      ? "Nastavi unos"

      : mobileOpenDefaultText;

  }



  function showAutosaveStatus(text, persistent) {

    if (!autosaveStatus) return;

    autosaveStatus.textContent = text || "";

    autosaveStatus.classList.toggle("is-visible", !!text);

    clearTimeout(autosaveStatusTimer);

    if (text && !persistent) {

      autosaveStatusTimer = setTimeout(() => {

        autosaveStatus.classList.remove("is-visible");

      }, 2600);

    }

  }



  function showSaveToast(text) {

    let toast = document.querySelector("[data-kb-save-toast]");

    if (!toast) {

      toast = document.createElement("div");

      toast.className = "kb-save-toast";

      toast.setAttribute("data-kb-save-toast", "1");

      toast.setAttribute("role", "status");

      toast.setAttribute("aria-live", "polite");

      document.body.appendChild(toast);

    }

    toast.textContent = text || "";

    window.requestAnimationFrame(() => {

      toast.classList.add("is-visible");

    });

    clearTimeout(saveToastTimer);

    saveToastTimer = setTimeout(() => {

      toast.classList.remove("is-visible");

    }, 3600);

  }



  function restoreLocalDraft() {

    const draft = readLocalDraft();

    if (!draft) return false;

    const config = draft && draft.config;

    if (!hasMeaningfulDraft(config)) return false;

    const urlVariant = new URLSearchParams(window.location.search).get("variant");

    const preserveVariant = !!urlVariant && Array.isArray(cfg.variants) && cfg.variants.some((variant) => String(variant.id) === urlVariant);

    const applied = applyDraftConfig(config, preserveVariant);

    updateMobileOpenButtonLabel();

    return applied;

  }



  function resetPrimaryTextMeasurement(config) {
    primaryTextBaseline = {
      street: String(config.street || ""),
      number: String(config.number || "")
    };
    primaryTextTouched.street = false;
    primaryTextTouched.number = false;
  }

  function notePrimaryTextInput(input, userInitiated) {
    if (!userInitiated || restoringDraft || primaryTextBaseline === null || !input) return;
    if (input.name === "street" || input.name === "number") {
      primaryTextTouched[input.name] = true;
    }
  }

  function primaryTextMeasurement(config) {
    return {
      street_changed: !!(primaryTextBaseline && primaryTextTouched.street &&
        String(config.street || "") !== primaryTextBaseline.street),
      number_changed: !!(primaryTextBaseline && primaryTextTouched.number &&
        String(config.number || "") !== primaryTextBaseline.number)
    };
  }

  function reportConfiguratorOpened(source) {
    if (configuratorOpenedReported || primaryTextBaseline === null ||
        document.visibilityState === "hidden" || !form) return;
    if (mobilePreviewEnabled() && !root.classList.contains("kb-mobile-modal-open")) return;
    const target = mobilePreviewEnabled() ? root : form;
    const rect = target.getBoundingClientRect();
    const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
    if (!target.getClientRects().length || rect.width <= 0 ||
        rect.right <= 0 || rect.left >= window.innerWidth ||
        visibleHeight < Math.min(48, rect.height) || rect.height <= 0) return;
    configuratorOpenedReported = true;
    if (configuratorVisibilityObserver) configuratorVisibilityObserver.disconnect();
    window.removeEventListener("scroll", checkConfiguratorVisibility);
    window.removeEventListener("resize", checkConfiguratorVisibility);
    document.removeEventListener("visibilitychange", checkConfiguratorVisibility);
    const config = currentConfig();
    void postLeadEvent("table_design_opened", {
      source: source || "visible",
      draft_source: initialDraftSource,
      product_handle: cfg.productHandle || "",
      product_id: cfg.productId || "",
      variant_id: selectedVariantId(),
      shape: config.shape,
      product_type: config.product_type,
      step: currentStep()
    });
  }

  function checkConfiguratorVisibility() {
    reportConfiguratorOpened("visible");
  }

  function initConfiguratorMeasurement() {
    resetPrimaryTextMeasurement(currentConfig());
    if (!form) return;
    if ("IntersectionObserver" in window) {
      configuratorVisibilityObserver = new IntersectionObserver(checkConfiguratorVisibility);
      configuratorVisibilityObserver.observe(form);
    }
    window.addEventListener("scroll", checkConfiguratorVisibility, { passive: true });
    window.addEventListener("resize", checkConfiguratorVisibility);
    document.addEventListener("visibilitychange", checkConfiguratorVisibility);
    checkConfiguratorVisibility();
  }

  function draftAnalyticsPayload(config, source) {

    return {

      source: source || "auto",
      ...primaryTextMeasurement(config),
      draft_source: initialDraftSource,

      product_handle: cfg.productHandle || "",

      product_id: cfg.productId || "",

      variant_id: selectedVariantId(),

      shape: config.shape,

      product_type: config.product_type,

      dimensions: `${config.width_cm || ""}x${config.height_cm || ""}`,

      street: config.street,

      number: config.number,

      extra_text: config.extra_text,

      characters: config.characters,

      contact_phone: config.contact_phone,

      plate_color: config.plate_color,

      text_color: config.text_color,

      distancer_color: config.distancer_color,

      engraving_color: config.engraving_color,

      step: currentStep()

    };

  }



  function saveLocalDraftNow(source) {

    if (restoringDraft) return;

    const config = currentConfig();

    const draftConfig = { ...config, step: currentStep() };

    const key = draftStorageKey();

    if (!hasMeaningfulDraft(draftConfig)) {

      safeLocalStorageRemove(key);

      updateMobileOpenButtonLabel();

      showAutosaveStatus("", true);

      return;

    }

    const draftSaved = safeLocalStorageSet(key, JSON.stringify({

      version: 1,

      saved_at: new Date().toISOString(),

      product_handle: cfg.productHandle || "",

      product_id: cfg.productId || "",

      config: draftConfig

    }));

    saveLastTextForRelatedProducts(draftConfig);

    updateMobileOpenButtonLabel();

    showAutosaveStatus(draftSaved ? "Nacrt sačuvan na ovom uređaju" : "Unos je dostupan dok je stranica otvorena", false);



    clearTimeout(draftAnalyticsTimer);

    const now = Date.now();

    const textChange = primaryTextMeasurement(config);
    const firstTextEdit = !primaryTextEditReported && (
      (textChange.street_changed && String(config.street || "").trim()) ||
      (textChange.number_changed && String(config.number || "").trim())
    );
    // Capture quick first entries; restored/default drafts retain the old cadence.
    const wait = firstTextEdit ? 500 : Math.max(DRAFT_ANALYTICS_DELAY_MS, DRAFT_ANALYTICS_MIN_INTERVAL_MS - (now - lastDraftAnalyticsAt));

    draftAnalyticsTimer = setTimeout(() => {

      lastDraftAnalyticsAt = Date.now();

      const analyticsConfig = currentConfig();
      const analyticsPayload = draftAnalyticsPayload(analyticsConfig, source);
      if ((analyticsPayload.street_changed && String(analyticsConfig.street || "").trim()) ||
          (analyticsPayload.number_changed && String(analyticsConfig.number || "").trim())) {
        primaryTextEditReported = true;
      }
      // Consume only the emitted interval; later color-only saves are not edits.
      resetPrimaryTextMeasurement(analyticsConfig);
      postLeadEvent("table_design_draft_saved", analyticsPayload).catch(() => {});

    }, wait);

  }



  function clearLocalDraft() {

    safeLocalStorageRemove(draftStorageKey());

    updateMobileOpenButtonLabel();

    showAutosaveStatus("", true);

  }



  function saveLastTextForRelatedProducts(config) {

    const group = designTextGroup(config);

    const key = lastTextStorageKey(group);

    if (!key) return;
    // Konfigurator autosnimi nacrt i sa PODRAZUMEVANIM vrednostima, cim se stranica
    // otvori. Bez ove provere takav snimak pregazi tekst koji je kupac uneo na
    // prethodnom obliku, pa mu se unos gubi pri promeni oblika.
    if (pristinePrimaryText === null) {
      try { pristinePrimaryText = draftPrimaryText(currentConfig()); } catch (e) { pristinePrimaryText = ""; }
    }
    if (!draftDiffersFromPristine(config)) return;

    const text = {

      street: config.street || "",

      number: config.number || "",

      extra_text: config.extra_text || "",

      characters: config.characters || "",

      contact_phone: config.contact_phone || ""

    };

    if (!Object.values(text).some(Boolean)) return;

    safeLocalStorageSet(key, JSON.stringify({

      version: 1,

      group,

      saved_at: new Date().toISOString(),

      product_handle: cfg.productHandle || "",

      product_id: cfg.productId || "",

      text

    }));

  }



  function scheduleDraftSave(source) {

    if (restoringDraft) return;

    clearTimeout(draftSaveTimer);

    draftSaveTimer = setTimeout(() => saveLocalDraftNow(source || "change"), DRAFT_SAVE_DELAY_MS);

  }



  function findVariantByDimension(widthCm, heightCm) {

    const target = { width_cm: normalizedNumber(widthCm), height_cm: normalizedNumber(heightCm) };

    if (!target.width_cm || !target.height_cm) return null;

    const variants = Array.isArray(cfg.variants) ? cfg.variants : [];

    return variants.find((variant) => {

      /* Varijanta "po meri" nema dimenziju u nazivu, pa currentDimension() za nju padne
         na ratioFallbackDimension i prijavi 40x20. Bez ove provere se lazno poklopi sa
         trazenih 40x20, izabere se varijanta od 1 RSD i nestane cena. Ista zastita vec
         postoji kod gradjenja liste dimenzija. QA 02.11.2026. */
      if (isCustomDimVariant(variant)) return false;
      const dims = currentDimension(variant);

      return sameDimension(dims, target);

    }) || null;

  }



  function selectVariantByDimension(widthCm, heightCm) {

    const variant = findVariantByDimension(widthCm, heightCm);

    if (!variant) return false;

    if (variantInput) {

      variantInput.value = String(variant.id);

      variantInput.dispatchEvent(new Event("change", { bubbles: true }));

    }

    const options = Array.isArray(variant.options) ? variant.options.map(String) : [];

    options.forEach((optionValue) => {

      document.querySelectorAll('variant-selects select, .product-form__input select').forEach((select) => {

        Array.from(select.options || []).forEach((option) => {

          if (String(option.value) === optionValue || String(option.textContent || "").trim() === optionValue) {

            select.value = option.value;

            select.dispatchEvent(new Event("change", { bubbles: true }));

          }

        });

      });

      document.querySelectorAll('variant-radios input[type="radio"], .product-form__input input[type="radio"]').forEach((input) => {

        if (String(input.value) === optionValue) {

          input.checked = true;

          input.dispatchEvent(new Event("change", { bubbles: true }));

        }

      });

    });

    return true;

  }



  function selectVariantByCharacterHeight(heightCm) {

    const target = normalizedNumber(heightCm);

    if (!target) return false;

    const variants = Array.isArray(cfg.variants) ? cfg.variants : [];

    const variant = variants.find((item) => {

      const parts = [item.title || ""].concat(Array.isArray(item.options) ? item.options : []);

      return parts.some((part) => parseCharacterHeight(part) === target);

    });

    if (!variant) return false;

    if (variantInput) {

      variantInput.value = String(variant.id);

      variantInput.dispatchEvent(new Event("change", { bubbles: true }));

    }

    applyVariantOptions(variant);

    return true;

  }



  function applyVariantOptions(variant) {

    const options = Array.isArray(variant.options) ? variant.options.map(String) : [];

    options.forEach((optionValue) => {

      document.querySelectorAll('variant-selects select, .product-form__input select').forEach((select) => {

        Array.from(select.options || []).forEach((option) => {

          if (String(option.value) === optionValue || String(option.textContent || "").trim() === optionValue) {

            select.value = option.value;

            select.dispatchEvent(new Event("change", { bubbles: true }));

          }

        });

      });

      document.querySelectorAll('variant-radios input[type="radio"], .product-form__input input[type="radio"]').forEach((input) => {

        if (String(input.value) === optionValue) {

          input.checked = true;

          input.dispatchEvent(new Event("change", { bubbles: true }));

        }

      });

    });

  }



  function activateCustomDimension() {

    const variant = customDimVariant();

    if (!variant) return false;

    customDimActive = true;

    if (variantInput) {

      variantInput.value = String(variant.id);

      variantInput.dispatchEvent(new Event("change", { bubbles: true }));

    }

    applyVariantOptions(variant);

    if (customDimWrap) customDimWrap.removeAttribute("hidden");

    return true;

  }



  function deactivateCustomDimension() {

    customDimActive = false;

    if (customDimWrap) customDimWrap.setAttribute("hidden", "");

  }



  function selectPreferredDefaultVariant() {

    const params = new URLSearchParams(window.location.search);

    if (params.get("variant")) return false;

    const preferred = preferredDefaultDimension();

    return selectVariantByDimension(preferred.width_cm, preferred.height_cm);

  }



  function applyIncomingConfigFromUrl() {

    const params = new URLSearchParams(window.location.search);

    if (params.get("kb_cfg") !== "1") return false;

    setField("street", params.get("kb_street"));

    setField("number", params.get("kb_number"));

    setField("extra_text", params.get("kb_extra"));

    setField("note", params.get("kb_note"));

    setField("script", params.get("kb_script"));

    setField("plate_color", params.get("kb_plate"));

    setField("text_color", params.get("kb_text"));

    setField("distancer_color", params.get("kb_dist"));

    setField("engraving_color", params.get("kb_engraving"));

    setField("number_align", params.get("kb_align"));

    setField("dog_symbol_key", params.get("kb_dog"));

    selectVariantByDimension(params.get("kb_w"), params.get("kb_h"));

    syncDistancerDefault();

    return true;

  }



  function escapeHtml(value) {

    return String(value || "").replace(/[&<>"']/g, (ch) => ({

      "&": "&amp;",

      "<": "&lt;",

      ">": "&gt;",

      '"': "&quot;",

      "'": "&#039;"

    })[ch]);

  }



  function dogSymbolBaseKey(key) {

    return String(key || "").replace(/_\d+$/g, "");

  }



  function dogSymbolRootKey(key) {

    return dogSymbolBaseKey(key).replace(/_\d+$/g, "");

  }



  function normalizeDogSearch(value) {

    return String(value || "")

      .toLowerCase()

      .replace(/\u0452/g, "dj")

      .replace(/\u0111/g, "dj")

      .normalize("NFD")

      .replace(/[\u0300-\u036f]/g, "")

      .replace(/[^a-z0-9]+/g, " ")

      .trim();

  }



  function dogSmartEntry(key) {

    return dogSmartNames[key] || dogSmartNames[dogSymbolBaseKey(key)] || dogSmartNames[dogSymbolRootKey(key)] || null;

  }



  async function loadDogSmartNames() {

    if (!cfg.dogSmartNamesUrl) return {};

    try {

      const res = await fetch(cfg.dogSmartNamesUrl, { cache: "force-cache" });

      if (!res.ok) return {};

      const data = await res.json();

      return data && (data.breeds || data) || {};

    } catch (err) {

      return {};

    }

  }



  function dogSymbolLabel(key, symbol) {

    const smart = dogSmartEntry(key);

    if (smart && smart.name) return smart.name;

    if (symbol && symbol.label) return symbol.label;

    return String(key || "")

      .replace(/_\d+$/g, (suffix) => " " + suffix.slice(1))

      .replace(/_/g, " ")

      .replace(/\b\w/g, (ch) => ch.toUpperCase());

  }



  function dogSymbolPreviewSvg(symbol) {

    if (!symbol || !symbol.viewBox || !Array.isArray(symbol.paths)) return "";

    return '<svg viewBox="' + escapeHtml(symbol.viewBox) + '" aria-hidden="true" focusable="false" preserveAspectRatio="xMidYMid meet">'

      + symbol.paths.map((d) => '<path d="' + escapeHtml(d) + '" fill="currentColor"/>').join("")

      + "</svg>";

  }



  function renderDogSymbolGrid(filterText) {

    if (!dogSymbolGrid) return;

    const tokens = normalizeDogSearch(filterText).split(/\s+/).filter(Boolean);

    const selected = field("dog_symbol_key") || "lovacki_01";

    const items = dogSymbols.filter((item) => !tokens.length || tokens.every((token) => item.search.indexOf(token) !== -1)).slice(0, 60);

    dogSymbolGrid.innerHTML = items.map((item) => {

      const active = item.key === selected;

      return '<button type="button" class="kb-dog-symbol-option" data-kb-dog-symbol-key="' + escapeHtml(item.key) + '" aria-pressed="' + (active ? "true" : "false") + '">'

        + '<span class="kb-dog-symbol-preview">' + dogSymbolPreviewSvg(item) + "</span>"

        + '<span class="kb-dog-symbol-name">' + escapeHtml(item.label) + "</span>"

        + "</button>";

    }).join("") || '<div class="kb-field-help">Nema rezultata za pretragu.</div>';

  }



  async function initDogSymbolPicker() {

    if (!dogSymbolPicker || !dogSymbolGrid) return;

    try {

      const rendererModule = await loadRendererModule();

      if (!rendererModule || typeof rendererModule.loadDogSymbolBundle !== "function") return;

      const results = await Promise.all([rendererModule.loadDogSymbolBundle(), loadDogSmartNames()]);

      const bundle = results[0] || {};

      dogSmartNames = results[1] || {};

      dogSymbols = Object.entries(bundle.symbols || {}).map(([key, symbol]) => {

        const smart = dogSmartEntry(key) || {};

        const item = {

          key,

          file: symbol.file || "",

          label: dogSymbolLabel(key, symbol),

          aliases: Array.isArray(smart.aliases) ? smart.aliases : [],

          viewBox: symbol.viewBox || "0 0 1000 1000",

          paths: Array.isArray(symbol.paths) ? symbol.paths : []

        };

        item.search = normalizeDogSearch([item.key, dogSymbolBaseKey(item.key), dogSymbolRootKey(item.key), item.label, item.file].concat(item.aliases).join(" "));

        return item;

      });

      if (!field("dog_symbol_key") && dogSymbols[0]) setField("dog_symbol_key", dogSymbols[0].key);

      renderDogSymbolGrid(dogSymbolSearch ? dogSymbolSearch.value : "");

    } catch (err) {

      dogSymbolGrid.innerHTML = '<div class="kb-field-help">Simboli pasa nisu učitani.</div>';

    }

  }



  function desktopPreviewEnabled() {

    return window.matchMedia && window.matchMedia("(min-width: 990px)").matches;

  }



  function mobilePreviewEnabled() {

    return window.matchMedia && window.matchMedia("(max-width: 749px)").matches;

  }



  function productGallery() {

    return document.querySelector("media-gallery, .product__media-wrapper");

  }



  function ensureGalleryPreview() {

    const gallery = productGallery();

    if (!gallery) return null;

    if (galleryPreview && gallery.contains(galleryPreview)) return galleryPreview;

    galleryPreview = document.createElement("div");

    galleryPreview.className = "kb-gallery-preview";

    galleryPreview.setAttribute("aria-live", "polite");

    galleryPreview.innerHTML = `

      <div class="kb-gallery-preview__head">

        <p class="kb-gallery-preview__title">Vaš dizajn</p>

        <p class="kb-gallery-preview__hint">Veliki pregled personalizacije</p>

      </div>

      <div class="kb-gallery-preview__stage" data-kb-gallery-preview-stage></div>

    `;

    gallery.insertBefore(galleryPreview, gallery.firstChild);

    return galleryPreview;

  }



  function activateGalleryPreview() {

    if (!desktopPreviewEnabled()) return;

    const gallery = productGallery();

    if (!gallery) return;

    galleryPreviewActive = true;

    ensureGalleryPreview();

    gallery.classList.add("kb-gallery-preview-active");

    root.classList.add("kb-desktop-gallery-active");

  }



  function syncGalleryPreview(svg) {

    if (!galleryPreviewActive || !desktopPreviewEnabled()) return;

    const mirror = ensureGalleryPreview();

    if (!mirror) return;

    const stage = mirror.querySelector("[data-kb-gallery-preview-stage]");

    if (stage) {

      stage.innerHTML = svg || "";

      const cfg = currentConfig();

      if (cfg.product_type !== "single_character" && cfg.width_cm && cfg.height_cm) {

        const mw = document.createElement("span");

        mw.className = "kb-dimension-marker kb-dimension-marker--width";

        mw.setAttribute("data-kb-dimension-width", "");

        mw.textContent = cfg.width_cm + " cm";

        const mh = document.createElement("span");

        mh.className = "kb-dimension-marker kb-dimension-marker--height";

        mh.setAttribute("data-kb-dimension-height", "");

        mh.innerHTML = "<strong>" + escapeHtml(cfg.height_cm) + " cm</strong>";

        stage.appendChild(mw);

        stage.appendChild(mh);

      }

      positionDimensionMarkers();

    }

    const gallery = productGallery();

    if (gallery) gallery.classList.add("kb-gallery-preview-active");

    root.classList.add("kb-desktop-gallery-active");

  }



  function updateMobilePreviewCompact() {

    if (!mobilePreviewEnabled()) {

      root.classList.remove("kb-mobile-preview-compact");

      return;

    }

    const rect = root.getBoundingClientRect();

    const compactAfter = Math.min(180, Math.max(120, window.innerHeight * 0.16));

    root.classList.toggle("kb-mobile-preview-compact", rect.top < -compactAfter);

  }



  function updateResponsivePreviewState() {

    syncConfiguratorMount();

    const gallery = productGallery();

    if (!desktopPreviewEnabled()) {

      root.classList.remove("kb-desktop-gallery-active");

      if (gallery) gallery.classList.remove("kb-gallery-preview-active");

    } else if (galleryPreviewActive && gallery) {

      root.classList.add("kb-desktop-gallery-active");

      gallery.classList.add("kb-gallery-preview-active");

      if (preview && preview.innerHTML) syncGalleryPreview(preview.innerHTML);

    }

    updateMobilePreviewCompact();

  }



  function syncConfiguratorMount() {

    if (mobilePreviewEnabled()) {

      if (root.parentElement !== document.body) document.body.appendChild(root);

      return;

    }

    if (root.parentElement === document.body && rootPlaceholder.parentNode) {

      rootPlaceholder.parentNode.insertBefore(root, rootPlaceholder.nextSibling);

    }

  }



  /* Automatsko otvaranje na mobilnom.
     Konfigurator je sustina ove stranice, a mereno je da 97,3% plitkih sesija nikad ne
     tapne dugme za otvaranje. Zato se na uskim ekranima otvara sam, uz tri ograde:
       - poseban analiticki razlog "mobile_auto", da dubina levka ostane merljiva
       - unos u istoriju, da sistemsko "nazad" zatvori modal umesto da napusti sajt
         (u IG/FB ugradjenom pregledacu je to glavni izlaz)
       - pamcenje zatvaranja za tu sesiju, da se ne nabija posetiocu ponovo */

  const AUTO_OPEN_KLJUC = "kb_auto_open_zatvoren";

  let istorijskiUnosGurnut = false;

  let zatvaranjeIzIstorije = false;

  function autoOpenOdbijen() {

    try { return sessionStorage.getItem(AUTO_OPEN_KLJUC) === "1"; } catch (e) { return false; }

  }

  function zapamtiZatvaranje() {

    try { sessionStorage.setItem(AUTO_OPEN_KLJUC, "1"); } catch (e) {}

  }

  function gurniIstorijskiUnos() {

    if (istorijskiUnosGurnut) return;

    try { history.pushState({ kbKonfigurator: true }, ""); istorijskiUnosGurnut = true; } catch (e) {}

  }

  window.addEventListener("popstate", () => {

    if (!root.classList.contains("kb-mobile-modal-open")) return;

    istorijskiUnosGurnut = false;

    zatvaranjeIzIstorije = true;

    closeMobileConfigurator();

    zatvaranjeIzIstorije = false;

  });

  /* Polja dolaze popunjena primerom, pa kupac vidi gotovu tablu sa tudjom adresom.

     Na prvi fokus se tekst oznaci, da ga prvi otkucaj zameni umesto da se dopisuje.

     Delegirano na root jer syncConfiguratorMount premesta polja u modal i

     osluskivaci na pojedinacnim poljima se tom prilikom gube. */

  const primeriPocetni = new Map();

  function pripremiPrimereUPoljima() {

    root.querySelectorAll('[name="street"], [name="number"], [name="extra_text"], [name="characters"]').forEach((el) => {

      if (el.value) primeriPocetni.set(el.name, el.value);

    });

  }

  root.addEventListener("focusin", (ev) => {

    const el = ev.target;

    if (!el || !el.name || !primeriPocetni.has(el.name)) return;

    if (el.value !== primeriPocetni.get(el.name)) return;

    try { el.select(); } catch (e) {}

  });

  function dovediPrvoPoljeUVidik() {

    const panel = root.querySelector(".kb-studio-layout");

    if (!panel || !root.classList.contains("kb-mobile-modal-open")) return;

    const polja = Array.prototype.slice
      .call(root.querySelectorAll(".kb-studio-form input, .kb-studio-form textarea"))
      .filter((el) => el.type !== "hidden" && el.offsetParent !== null &&
                      el.getBoundingClientRect().height > 0);

    if (!polja.length) return;

    const okvir = panel.getBoundingClientRect();

    /* Apsolutni racun, ne dodavanje: kad se pregled smanji, skrol se i SMANJUJE,
       pa vrh table ne ostaje odsecen od ranijeg, vecег skrola. */

    const dnoUSadrzaju = polja[0].getBoundingClientRect().bottom - okvir.top + panel.scrollTop;

    const zeljeni = Math.max(0, Math.ceil(dnoUSadrzaju - panel.clientHeight + 8));

    if (panel.scrollHeight <= panel.clientHeight) return zeljeni === 0;

    if (Math.abs(panel.scrollTop - zeljeni) > 1) panel.scrollTop = zeljeni;

    return Math.round(polja[0].getBoundingClientRect().bottom - okvir.bottom) <= 0;

  }

  function dovediPrvoPoljeUVidikUporno() {

    /* Premium stranica se sleze i posle 3,5 s (jezicci, scena, Google sekcija),
       pa su fiksni pokusaji tiho promasivali. Sada se pokusava dok ne uspe. */

    let preostalo = 14;

    const tik = () => {

      if (--preostalo < 0) return;

      if (!root.classList.contains("kb-mobile-modal-open")) return;

      syncDonjiSloj();

      if (dovediPrvoPoljeUVidik()) return;

      setTimeout(tik, 600);

    };

    setTimeout(tik, 400);

  }

  function syncDonjiSloj() {

    if (!mobilePreviewEnabled() || !root.classList.contains("kb-mobile-modal-open")) {

      root.style.removeProperty("--kb-donji-sloj");

      return;

    }

    let visina = 0;

    document.querySelectorAll(".shopify-pc__banner__dialog, .shopify-pc__banner").forEach((el) => {

      const r = el.getBoundingClientRect();

      if (r.height > 0 && r.bottom > window.innerHeight - 4) visina = Math.max(visina, r.height);

    });

    root.style.setProperty("--kb-donji-sloj", Math.round(visina) + "px");

  }

  /* Baner se crta kasno i nestaje kad ga posetilac sklopi, pa se mera osvezava. */
  window.addEventListener("resize", syncDonjiSloj);

  document.addEventListener("click", () => {

    requestAnimationFrame(syncDonjiSloj);

  }, true);

  /* Pregled se docrtava posle prvog uspesnog skrola i opet gurne polje van vidika,
     pa se posle svake promene visine provera ponavlja dok je modal otvoren. */

  let posmatracPregleda = null;

  function pratiPromeneVisine() {

    if (posmatracPregleda || typeof ResizeObserver === "undefined") return;

    const karta = root.querySelector(".kb-studio-preview-card");

    if (!karta) return;

    posmatracPregleda = new ResizeObserver(() => {

      if (!root.classList.contains("kb-mobile-modal-open")) return;

      syncDonjiSloj();

      dovediPrvoPoljeUVidik();

    });

    posmatracPregleda.observe(karta);

    const panel = root.querySelector(".kb-studio-layout");

    if (panel) posmatracPregleda.observe(panel);

  }

  function autoOpenMobileConfigurator() {

    if (!mobilePreviewEnabled()) return;

    if (autoOpenOdbijen()) return;

    if (root.classList.contains("kb-mobile-modal-open")) return;

    openMobileConfigurator("mobile_auto");

  }

  function openMobileConfigurator(razlog) {

    if (!mobilePreviewEnabled()) return;

    syncConfiguratorMount();

    root.classList.add("kb-mobile-modal-open");

    root.classList.remove("kb-mobile-preview-compact");

    document.body.classList.add("kb-configurator-open");

    if (mobileOpenButton) mobileOpenButton.setAttribute("aria-expanded", "true");

    setWizardStep(currentStep());

    updateResponsivePreviewState();
    gurniIstorijskiUnos();

    syncDonjiSloj();

    pratiPromeneVisine();
    dovediPrvoPoljeUVidikUporno();

    reportConfiguratorOpened(typeof razlog === "string" ? razlog : "mobile_open");

  }



  function closeMobileConfigurator() {

    const config = currentConfig();

    if (hasMeaningfulDraft(config)) {

      saveLocalDraftNow("mobile_close");

      showAutosaveStatus("Unos je sačuvan. Možete nastaviti kasnije.", true);

      showSaveToast("Unos je sačuvan. Možete nastaviti kasnije.");

    }

    root.classList.remove("kb-mobile-modal-open");

    root.classList.remove("kb-mobile-preview-compact");

    document.body.classList.remove("kb-configurator-open");

    if (mobileOpenButton) mobileOpenButton.setAttribute("aria-expanded", "false");

    updateResponsivePreviewState();

    zapamtiZatvaranje();

    if (istorijskiUnosGurnut && !zatvaranjeIzIstorije) {

      istorijskiUnosGurnut = false;

      try { history.back(); } catch (e) {}

    }

  }



  function syncMobileConfiguratorMode() {

    syncConfiguratorMount();

    if (!mobilePreviewEnabled()) closeMobileConfigurator();

  }



  function fitInlinePreviewSvg() {

    if (!preview) return;

    const svg = preview.querySelector("svg");

    if (!svg) return;

    preview.style.setProperty("--kb-preview-fit-scale", "1");

    window.requestAnimationFrame(() => {

      const previewRect = preview.getBoundingClientRect();

      const svgRect = svg.getBoundingClientRect();

      if (!previewRect.width || !previewRect.height || !svgRect.width || !svgRect.height) return;

      const maxWidth = previewRect.width - 18;

      const maxHeight = previewRect.height - 18;

      const scale = Math.min(1, maxWidth / svgRect.width, maxHeight / svgRect.height);

      preview.style.setProperty("--kb-preview-fit-scale", String(Math.max(0.72, Math.floor(scale * 100) / 100)));

    });

  }



  function ensureDimensionMarkers() {

    if (!preview) return;

    let widthMarker = preview.querySelector("[data-kb-dimension-width]");

    let heightMarker = preview.querySelector("[data-kb-dimension-height]");

    if (!widthMarker) {

      widthMarker = document.createElement("span");

      widthMarker.className = "kb-dimension-marker kb-dimension-marker--width";

      widthMarker.setAttribute("data-kb-dimension-width", "");

      preview.appendChild(widthMarker);

    }

    if (!heightMarker) {

      heightMarker = document.createElement("span");

      heightMarker.className = "kb-dimension-marker kb-dimension-marker--height";

      heightMarker.setAttribute("data-kb-dimension-height", "");

      preview.appendChild(heightMarker);

    }

    if (!dimResizeObserver && typeof ResizeObserver === "function") {

      dimResizeObserver = new ResizeObserver(function () { positionDimensionMarkers(); });

      dimResizeObserver.observe(preview);

    }

  }



  function updateDimensionMarkers() {

    if (!preview) return;

    const config = currentConfig();

    ensureDimensionMarkers();

    const widthMarker = preview.querySelector("[data-kb-dimension-width]");

    const heightMarker = preview.querySelector("[data-kb-dimension-height]");

    if (config.product_type === "single_character") {

      if (widthMarker) widthMarker.textContent = "";

      if (heightMarker) heightMarker.innerHTML = "";

      return;

    }

    if (widthMarker) widthMarker.textContent = config.width_cm ? `${config.width_cm} cm` : "";

    if (heightMarker) {

      heightMarker.innerHTML = config.height_cm

        ? `<strong>${escapeHtml(config.height_cm)} cm</strong>`

        : "";

    }

    positionDimensionMarkers();

  }



  // Markeri mere moraju da leže tačno na ivicama table. Ranije su bili

  // zakucani na 17%/18% kutije pregleda, pa je strelica "40 cm" pokrivala

  // 88% širine a linija "20 cm" 128% visine — kupac je čitao pogrešnu meru.

  function plateRectOnScreen(svg) {

    try {

      const ctm = svg.getScreenCTM();

      if (!ctm) return null;

      const vb = svg.viewBox && svg.viewBox.baseVal;

      const x0 = vb && vb.width ? vb.x : 0;

      const y0 = vb && vb.height ? vb.y : 0;

      const x1 = vb && vb.width ? vb.x + vb.width : 0;

      const y1 = vb && vb.height ? vb.y + vb.height : 0;

      if (x1 === x0 || y1 === y0) return svg.getBoundingClientRect();

      const p0 = svg.createSVGPoint(); p0.x = x0; p0.y = y0;

      const p1 = svg.createSVGPoint(); p1.x = x1; p1.y = y1;

      const a = p0.matrixTransform(ctm);

      const b = p1.matrixTransform(ctm);

      return {

        left: Math.min(a.x, b.x),

        top: Math.min(a.y, b.y),

        width: Math.abs(b.x - a.x),

        height: Math.abs(b.y - a.y)

      };

    } catch (e) {

      return svg.getBoundingClientRect();

    }

  }



  // Postavlja markere tacno na ivice table unutar datog kontejnera.

  // CSS `left/top` se meri od padding-ivice, pa se oduzima debljina okvira.

  function layoutMarkersIn(box) {

    if (!box) return;

    const svg = box.querySelector("svg");

    const mw = box.querySelector("[data-kb-dimension-width]");

    const mh = box.querySelector("[data-kb-dimension-height]");

    if (!svg || !mw || !mh) return;

    const br = box.getBoundingClientRect();

    if (!br.width || !br.height) return;

    const sr = plateRectOnScreen(svg);

    if (!sr || !sr.width || !sr.height) return;

    const cs = window.getComputedStyle(box);

    const bl = parseFloat(cs.borderLeftWidth) || 0;

    const brw = parseFloat(cs.borderRightWidth) || 0;

    const bt = parseFloat(cs.borderTopWidth) || 0;

    const bb = parseFloat(cs.borderBottomWidth) || 0;

    const levo = sr.left - br.left - bl;

    const desno = br.right - (sr.left + sr.width) - brw;

    const gore = sr.top - br.top - bt;

    const dole = br.bottom - (sr.top + sr.height) - bb;

    const st = box.style;

    st.setProperty("--kb-dim-w-left", levo + "px");

    st.setProperty("--kb-dim-w-right", desno + "px");

    st.setProperty("--kb-dim-w-bottom", Math.max(4, dole - 29) + "px");

    st.setProperty("--kb-dim-h-top", gore + "px");

    st.setProperty("--kb-dim-h-bottom", dole + "px");

    const linijaX = Math.min(br.width - 6, levo + sr.width + 9);

    st.setProperty("--kb-dim-h-left", (linijaX - 27) + "px");

    st.setProperty("--kb-dim-h-right", "auto");

  }



  function positionDimensionMarkers() {

    window.requestAnimationFrame(function () {

    window.requestAnimationFrame(function () {

      layoutMarkersIn(preview);

      layoutMarkersIn(galleryStage());

    });

    });

  }



  function galleryStage() {

    return galleryPreview ? galleryPreview.querySelector("[data-kb-gallery-preview-stage]") : null;

  }



  function luminance(color) {

    const map = {

      crna: 0.02,

      teget: 0.05,

      braon: 0.06,

      plava: 0.10,

      crvena: 0.12,

      antracit: 0.35,

      siva: 0.50,

      srebrna_metalik: 0.36,

      srebrno_ogledalo: 0.76,

      zlatno_ogledalo: 0.68,

      bela: 0.96,

      srebrna: 0.78,

      zlatna: 0.70

    };

    return map[color] == null ? 0.5 : map[color];

  }



  function updateContrastWarning() {

    if (!contrastWarning) return;

    const plate = field("plate_color");

    const text = field("text_color");

    const weak = Math.abs(luminance(plate) - luminance(text)) < 0.34;

    contrastWarning.hidden = !weak;

  }



  function applyBetterContrast() {

    if (!form) return false;

    const plateSelect = form.querySelector('[name="plate_color"]');

    const textSelect = form.querySelector('[name="text_color"]');

    const distancerSelect = form.querySelector('[name="distancer_color"]');

    if (!plateSelect || !textSelect) return false;

    const plate = field("plate_color");

    const next = isMailboxMirrorTextLocked()

      ? { plate: "crna", text: "srebrno_ogledalo", distancer: "srebrna" }

      : (luminance(plate) > 0.55

        ? { plate, text: "crna", distancer: "srebrna" }

        : { plate, text: "srebrno_ogledalo", distancer: "srebrna" });

    plateSelect.value = next.plate;

    textSelect.value = next.text;

    if (distancerSelect) distancerSelect.value = next.distancer;

    syncMailboxMirrorTextLock();

    updateSwatches();

    schedulePreview();

    postLeadEvent("table_design_color_preset_click", {

      product_handle: cfg.productHandle || "",

      preset: "Primeni bolju kombinaciju",

      plate_color: next.plate,

      text_color: next.text,

      distancer_color: next.distancer,

      source: "contrast_warning"

    }).catch(() => {});

    return true;

  }



  // The footer follows the cart action once its inline button is reached.
  function mobileCartActionActive() {
    if (currentStep() === wizardSteps[wizardSteps.length - 1]) return true;
    if (!mobilePreviewEnabled() || !root.classList.contains("kb-mobile-modal-open") || !addButton) return false;
    const scroller = root.querySelector(".kb-studio-layout");
    const controls = root.querySelector(".kb-wizard-controls");
    if (!scroller || !controls) return false;
    const target = addButton.getBoundingClientRect();
    const area = scroller.getBoundingClientRect();
    const footer = controls.getBoundingClientRect();
    const bottom = Math.min(area.bottom, footer.top);
    return target.width > 0 && target.height > 0 && target.top + target.height * 0.5 <= bottom;
  }

  function syncWizardPrimaryAction() {
    if (dodavanjeUToku) return;
    const cartAction = mobileCartActionActive();
    const valid = !cartAction || validateConfig(currentConfig()).ok;
    root.querySelectorAll("[data-kb-step-next]").forEach((button) => {
      button.dataset.kbPrimaryAction = cartAction ? "cart" : "next";
      button.textContent = cartAction ? "Dodaj u korpu" : (wizardStepActions[currentStep()] || "Dalje");
      button.disabled = !valid;
      button.classList.toggle("is-disabled", !valid);
      button.setAttribute("aria-disabled", valid ? "false" : "true");
    });
  }

  let wizardActionFrame = 0;
  function scheduleWizardPrimaryAction() {
    if (wizardActionFrame) return;
    wizardActionFrame = window.requestAnimationFrame(() => {
      wizardActionFrame = 0;
      syncWizardPrimaryAction();
    });
  }

  function initWizardPrimaryActionSync() {
    const scroller = root.querySelector(".kb-studio-layout");
    if (scroller) scroller.addEventListener("scroll", scheduleWizardPrimaryAction, { passive: true });
    window.addEventListener("resize", scheduleWizardPrimaryAction, { passive: true });
    if (typeof ResizeObserver !== "undefined") {
      const observer = new ResizeObserver(scheduleWizardPrimaryAction);
      if (scroller) observer.observe(scroller);
      if (addButton) observer.observe(addButton);
      const actions = root.querySelector(".kb-table-designer__actions");
      if (actions) observer.observe(actions);
    }
    scheduleWizardPrimaryAction();
  }

  function setActiveStep(step) {

    const next = wizardSteps.includes(step) ? step : "text";

    root.dataset.kbActiveStep = next;

    root.querySelectorAll("[data-kb-step-jump]").forEach((button) => {

      button.setAttribute("aria-pressed", button.dataset.kbStepJump === next ? "true" : "false");

    });

    const index = wizardSteps.indexOf(next);

    const progress = root.querySelector("[data-kb-step-progress-fill]");

    const label = root.querySelector("[data-kb-step-label]");

    const title = root.querySelector("[data-kb-step-title]");

    if (progress) progress.style.setProperty("--kb-step-progress", `${((index + 1) / wizardSteps.length) * 100}%`);

    if (label) label.textContent = `Korak ${index + 1} od ${wizardSteps.length}`;

    if (title) title.textContent = wizardStepTitles[next] || "";

    root.querySelectorAll("[data-kb-step-prev]").forEach((button) => {

      button.disabled = index <= 0;

    });

    syncWizardPrimaryAction();
    scheduleWizardPrimaryAction();

    if (next === wizardSteps[wizardSteps.length - 1]) syncValidationState(false);

  }



  function stepIndex(step) {

    const index = wizardSteps.indexOf(step);

    return index < 0 ? 0 : index;

  }



  function currentStep() {

    return root.dataset.kbActiveStep || "text";

  }



  function resetMobileStepScroll() {

    if (!mobilePreviewEnabled() || !root.classList.contains("kb-mobile-modal-open")) return;

    const scroller = root.querySelector(".kb-studio-layout");

    if (!scroller) return;

    window.requestAnimationFrame(() => {

      scroller.scrollTop = 0;

    });

  }



  function setWizardStep(step) {

    const next = wizardSteps[stepIndex(step)];

    const section = root.querySelector(`[data-kb-step-section="${next}"]`);

    if (section && section.tagName === "DETAILS") section.open = true;

    if (mobilePreviewEnabled()) root.classList.remove("kb-mobile-preview-compact");

    setActiveStep(next);

    resetMobileStepScroll();

    updateMobilePreviewCompact();

  }



  function stepScrollOffset() {

    if (mobilePreviewEnabled()) {

      const previewCard = root.querySelector(".kb-studio-preview-card");

      const stickyTop = parseFloat(getComputedStyle(root).getPropertyValue("--kb-mobile-sticky-top")) || 66;

      const previewHeight = previewCard ? previewCard.getBoundingClientRect().height : 0;

      return Math.ceil(stickyTop + previewHeight + 18);

    }

    return desktopPreviewEnabled() ? 28 : 72;

  }



  function scrollToStep(step) {

    if (mobilePreviewEnabled()) {

      setWizardStep(step);

      return;

    }

    const section = root.querySelector(`[data-kb-step-section="${step}"]`);

    if (!section) return;

    if (section.tagName === "DETAILS") section.open = true;

    if (mobilePreviewEnabled()) {

      root.classList.add("kb-mobile-preview-compact");

      void root.offsetHeight;

    }

    const top = window.scrollY + section.getBoundingClientRect().top - stepScrollOffset();

    activeStepLockUntil = Date.now() + 1000;

    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });

    setActiveStep(step);

    window.setTimeout(updateActiveStepFromScroll, 1050);

  }



  function mountMobileCheckoutBar() {

    if (!mobileCheckoutBar || mobileCheckoutBar.parentElement === document.body) return;

    document.body.appendChild(mobileCheckoutBar);

  }



  function updateActiveStepFromScroll() {

    if (mobilePreviewEnabled()) return;

    if (Date.now() < activeStepLockUntil) return;

    const sections = Array.from(root.querySelectorAll("[data-kb-step-section]"));

    if (!sections.length) return;

    const focusLine = mobilePreviewEnabled() ? stepScrollOffset() : 170;

    let active = sections[0].dataset.kbStepSection || "text";

    let closestDistance = Infinity;

    sections.forEach((section) => {

      const rect = section.getBoundingClientRect();

      const distance = Math.abs(rect.top - focusLine);

      if (distance < closestDistance) {

        closestDistance = distance;

        active = section.dataset.kbStepSection || active;

      }

    });

    setActiveStep(active);

  }



  function fallbackPreviewSvg(config) {

    const w = Number(config.width_cm || 40);

    const h = Number(config.height_cm || 20);

    const street = escapeHtml(config.street || "Naziv ulice");

    const number = escapeHtml(config.number || "12A");

    const bg = config.background_color === "bela" ? "#f8fafc" : "#151515";

    const fg = ["zlatna", "zlatno_ogledalo"].includes(config.text_color) ? "#c59b43" : "#f8fafc";

    return `<svg xmlns="http://www.w3.org/2000/svg" width="${w * 10}mm" height="${h * 10}mm" viewBox="0 0 ${w} ${h}">

  <rect x="0.35" y="0.35" width="${w - 0.7}" height="${h - 0.7}" rx="0.8" fill="${bg}" stroke="#999" stroke-width="0.15"/>

  <text x="${w / 2}" y="${h * 0.43}" text-anchor="middle" dominant-baseline="middle" font-family="Arial, sans-serif" font-size="${h * 0.34}" font-weight="700" fill="${fg}">${number}</text>

  <line x1="${w * 0.18}" x2="${w * 0.82}" y1="${h * 0.58}" y2="${h * 0.58}" stroke="${fg}" stroke-width="0.12"/>

  <text x="${w / 2}" y="${h * 0.74}" text-anchor="middle" dominant-baseline="middle" font-family="Arial, sans-serif" font-size="${h * 0.13}" fill="${fg}">${street}</text>

</svg>`;

  }



  let rendererImportAttempt = 0;
  async function loadRendererModule() {
    if (!cfg.rendererUrl) return null;
    if (!rendererModulePromise) {
      const url = new URL(cfg.rendererUrl, location.href);
      if (rendererImportAttempt) url.searchParams.set('kb_flow_retry', String(rendererImportAttempt));
      const pending = flowDeadline(import(url.href), 12000, 'render');
      rendererModulePromise = pending.catch(error => {
        rendererModulePromise = null;
        rendererImportAttempt++;
        throw error;
      });
    }
    return rendererModulePromise;
  }

  // Use the existing visual render; package its material images for SVG <img> use.
  // Optional scene work must never prevent the existing design/cart save.
  async function portableSceneSvg(svg) {
    try {
      const doc = new DOMParser().parseFromString(svg, "image/svg+xml");
      if (doc.querySelector("parsererror") || doc.documentElement.localName !== "svg") throw new Error("Invalid preview");
      const cache = new Map();
      await Promise.all(Array.from(doc.querySelectorAll("image")).map(async (image) => {
        const href = image.getAttribute("href") || image.getAttributeNS("http://www.w3.org/1999/xlink", "href");
        if (!href) throw new Error("Missing material");
        if (/^data:image\/(png|jpeg|webp);base64,/i.test(href)) return;
        const key = href.startsWith("/assets/table_designer/") ? href.slice("/assets/table_designer/".length) : "";
        const mapped = key && (window.KB_TABLE_RENDERER_ASSETS || {})[key];
        const rendererBase = new URL(cfg.rendererUrl || location.href, location.href);
        const url = new URL(mapped || href, rendererBase);
        if (url.protocol !== "https:" || ![location.hostname, "cdn.shopify.com", "app.fordservisbeograd.rs"].includes(url.hostname)) throw new Error("Invalid material host");
        if (!cache.has(url.href)) cache.set(url.href, (async () => {
          const response = await fetch(url.href, {credentials: "omit", signal: AbortSignal.timeout(6000)});
          if (!response.ok) throw new Error("Material unavailable");
          const bitmap = await createImageBitmap(await response.blob());
          try {
            const scale = Math.min(1, 1024 / Math.max(bitmap.width, bitmap.height));
            const canvas = document.createElement("canvas");
            canvas.width = Math.max(1, Math.round(bitmap.width * scale));
            canvas.height = Math.max(1, Math.round(bitmap.height * scale));
            canvas.getContext("2d").drawImage(bitmap, 0, 0, canvas.width, canvas.height);
            return canvas.toDataURL("image/webp", 0.86);
          } finally { bitmap.close(); }
        })());
        const dataUrl = await cache.get(url.href);
        image.setAttribute("href", dataUrl);
        image.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", dataUrl);
      }));
      const content = new XMLSerializer().serializeToString(doc.documentElement);
      if (new Blob([content]).size > 4500000) throw new Error("Preview too large");
      return {svg: content, ready: true};
    } catch (_) { return {svg, ready: false}; }
  }

  async function buildRenderFiles(config) {

    if (!syncValidationState(true)) throw new Error(HOUSE_NUMBER_MESSAGE);

    const rendererModule = await loadRendererModule();

    if (rendererModule && typeof rendererModule.renderTableDesign === "function") {

      const rendered = await rendererModule.renderTableDesign(config);

      const files = rendered.files || {};

      const visualPreviewSvg = rendered.preview && rendered.preview.svg

        ? rendered.preview.svg

        : (files.preview_svg && files.preview_svg.content ? files.preview_svg.content : "");

      return {

        preview_svg: visualPreviewSvg,

        corel_svg: files.corel_svg && files.corel_svg.content ? files.corel_svg.content : "",

        layer2_svg: files.layer2_svg && files.layer2_svg.content ? files.layer2_svg.content : "",

        combined_svg: files.combined_svg && files.combined_svg.content ? files.combined_svg.content : "",

        laser_svg: files.laser_svg && files.laser_svg.content ? files.laser_svg.content : "",

        json: files.json && files.json.content ? files.json.content : JSON.stringify(rendered, null, 2),

        filenames: {

          preview_svg: files.preview_svg && files.preview_svg.filename,

          corel_svg: files.corel_svg && files.corel_svg.filename,

          layer2_svg: files.layer2_svg && files.layer2_svg.filename,

          combined_svg: files.combined_svg && files.combined_svg.filename,

          laser_svg: files.laser_svg && files.laser_svg.filename,

          json: files.json && files.json.filename

        },

        warnings: rendered.warnings || []

      };

    }



    if (window.KBHousePlateRenderer && typeof window.KBHousePlateRenderer.render === "function") {

      return window.KBHousePlateRenderer.render(config);

    }



    const previewSvg = fallbackPreviewSvg(config);

    return {

      preview_svg: previewSvg,

      combined_svg: previewSvg,

      json: JSON.stringify(config, null, 2),

      warnings: ["Privremeni rezervni pregled. Renderer nije učitan, proveriti kb-table-renderer.js."]

    };

  }



  function contentFile(filename, content, mime) {

    return { filename, mime, content };

  }



  function base64File(filename, contentBase64, mime) {

    return { filename, mime, content_base64: contentBase64 };

  }



  function blobToBase64(blob) {

    return new Promise((resolve, reject) => {

      const reader = new FileReader();

      reader.onload = () => resolve(String(reader.result || "").split(",")[1] || "");

      reader.onerror = reject;

      reader.readAsDataURL(blob);

    });

  }



  async function addPreviewPngFile(config, files) {

    const rendererModule = await loadRendererModule();

    if (!rendererModule || typeof rendererModule.renderPreviewPngBlob !== "function") return;

    const blob = await rendererModule.renderPreviewPngBlob(config);

    if (!(blob instanceof Blob) || !blob.size) return;

    files.preview_png = base64File("preview.png", await blobToBase64(blob), "image/png");

  }



  async function buildPayload(config, renderFiles) {

    const variant = selectedVariant();

    const filenames = renderFiles.filenames || {};

    const payloadConfig = config.product_type === "single_character"

      ? { ...config, street: config.characters, number: config.characters }

      : config;

    const scenePreview = await portableSceneSvg(renderFiles.preview_svg);
    renderFiles.scene_preview_ready = scenePreview.ready;
    const files = {

      preview_svg: contentFile(filenames.preview_svg || "preview.svg", scenePreview.svg, "image/svg+xml"),

      combined_svg: contentFile(filenames.combined_svg || "komplet.svg", renderFiles.combined_svg, "image/svg+xml"),

      json: contentFile(filenames.json || "design.json", renderFiles.json || JSON.stringify(payloadConfig), "application/json")

    };

    if (renderFiles.corel_svg) files.corel_svg = contentFile(filenames.corel_svg || "corel.svg", renderFiles.corel_svg, "image/svg+xml");

    if (renderFiles.layer2_svg) files.layer2_svg = contentFile(filenames.layer2_svg || "layer2.svg", renderFiles.layer2_svg, "image/svg+xml");

    if (renderFiles.laser_svg) files.laser_svg = contentFile(filenames.laser_svg || "laser.svg", renderFiles.laser_svg, "image/svg+xml");

    try {
      // A late result cannot mutate the payload after it has been sent.
      const optionalFiles = {};
      await flowDeadline(addPreviewPngFile(config, optionalFiles), 2500, 'png');
      if (optionalFiles.preview_png) files.preview_png = optionalFiles.preview_png;
    } catch (error) {
      try {
        if (!scenePreview.ready) throw error;
        const blob = await flowPngFromSvg(scenePreview.svg);
        files.preview_png = base64File("preview.png", await blobToBase64(blob), "image/png");
      } catch (_) {
        reportFlowOutcome('table_design_flow_error', { stage: 'png', code: 'OPTIONAL_PREVIEW_FAILED' }, flowOperation);
      }
    }



    return {

      shopify: {

        shop: cfg.shop || "",

        product: {

          id: cfg.productId || "",

          handle: cfg.productHandle || ""

        },

        variant: {

          id: variant.id || selectedVariantId(),

          title: variant.title || ""

        }

      },

      visitor: visitorIdentity(),

      config: payloadConfig,

      warnings: renderFiles.warnings || [],

      files

    };

  }



  function alternateProductUrl(shapeInfo, config) {

    const params = new URLSearchParams();

    params.set("kb_cfg", "1");

    params.set("kb_street", config.street || "");

    params.set("kb_number", shapeInfo.natpisOnly ? "" : (config.number || ""));

    params.set("kb_extra", config.extra_text || "");

    params.set("kb_note", config.note || "");

    params.set("kb_script", config.script || "cyrillic");

    params.set("kb_plate", config.plate_color || "crna");

    params.set("kb_text", config.text_color || "srebrno_ogledalo");

    params.set("kb_dist", config.distancer_color || "srebrna");

    params.set("kb_engraving", config.engraving_color || "");

    params.set("kb_align", config.number_align || "right");

    params.set("kb_dog", config.dog_symbol_key || "");

    params.set("kb_w", String(shapeInfo.width_cm || config.width_cm || ""));

    params.set("kb_h", String(shapeInfo.height_cm || config.height_cm || ""));

    if (shapeInfo.productHandle) {

      return `/products/${shapeInfo.productHandle}?${params.toString()}`;

    }

    if (shapeInfo.shape === "oblik_4") {

      return `/products/oblik-4-linije?${params.toString()}`;

    }

    if (shapeInfo.shape === "oblik_4_srpski") {

      return `/products/oblik-4-srpski?${params.toString()}`;

    }

    if (shapeInfo.shape === "oblik_4_retro") {

      return `/products/oblik-4-retro?${params.toString()}`;

    }

    if (shapeInfo.shape === "oblik_4_pola_pola") {

      return `/products/oblik-4-2-1-pola-pola?${params.toString()}`;

    }

    return `/products/oblik-${shapeInfo.handlePart}-${ratioSlug()}?${params.toString()}`;

  }



  async function renderAlternateShapes() {

    if (!alternateShapes || !alternateShapesGrid) return;

    const base = currentConfig();

    const isHouseNumber = base.product_type === "house_number";

    const isApartmentPlate = base.product_type === "apartment_plate";

    if ((!isHouseNumber && !isApartmentPlate) || !base.width_cm || !base.height_cm) {

      alternateShapes.hidden = true;

      alternateShapesGrid.innerHTML = "";

      return;

    }

    const currentShape = base.shape;

    const sourceOptions = isApartmentPlate ? apartmentPlateShapeOptions : houseShapeOptions;

    const options = sourceOptions.filter((item) => isApartmentPlate

      ? item.productHandle !== cfg.productHandle

      : item.shape !== currentShape);

    if (!options.length) {

      alternateShapes.hidden = true;

      alternateShapesGrid.innerHTML = "";

      return;

    }



    const seq = ++alternateRenderSeq;

    alternateShapes.hidden = false;

    alternateShapesGrid.innerHTML = options.map((item) => `

      <a class="kb-alternate-shape" href="${escapeHtml(alternateProductUrl(item, base))}" data-kb-alternate-shape="${escapeHtml(item.key || item.shape)}" data-kb-alternate-label="${escapeHtml(item.label)}">

        <span class="kb-alternate-shape__preview" aria-hidden="true"></span>

        <span class="kb-alternate-shape__label">${escapeHtml(item.label)}</span>

        <span class="kb-alternate-shape__hint">Isti tekst</span>

      </a>

    `).join("");



    const rendererModule = await loadRendererModule();

    if (seq !== alternateRenderSeq) return;

    await Promise.all(options.map(async (item) => {

      const card = alternateShapesGrid.querySelector(`[data-kb-alternate-shape="${item.key || item.shape}"] .kb-alternate-shape__preview`);

      if (!card) return;

      const previewConfig = {

        ...base,

        shape: item.shape,

        plate_shape: item.shape,

        width_cm: item.width_cm || base.width_cm,

        height_cm: item.height_cm || base.height_cm,

        number: item.natpisOnly ? "" : base.number,

        number_align: centerNumberShapes.has(item.shape) ? base.number_align : "right"

      };

      try {

        if (rendererModule && typeof rendererModule.renderTableDesign === "function") {

          const rendered = await rendererModule.renderTableDesign(previewConfig);

          if (seq === alternateRenderSeq) card.innerHTML = rendered.preview && rendered.preview.svg ? rendered.preview.svg : "";

        } else {

          card.innerHTML = fallbackPreviewSvg(previewConfig);

        }

      } catch (err) {
        sendRenderErrorBeacon(err, previewConfig, "alternate_shape_preview");
        if (seq === alternateRenderSeq) card.innerHTML = fallbackPreviewSvg(previewConfig);
      }
    }));

  }



  function scheduleAlternateShapes() {

    clearTimeout(alternateRenderTimer);

    alternateRenderTimer = setTimeout(() => {

      renderAlternateShapes().catch(() => {});

    }, 220);

  }



  async function saveDesign(config = currentConfig(), operation = null) {
    flowStage = "validation";
    const validation = validateConfig(config);
    if (!validation.ok) throw new Error(validation.message);
    if (config.product_type === "video_notice") {
      if (!config.street || !config.extra_text) throw new Error("Unesite gornji i donji tekst.");
    } else if (config.product_type === "mailbox") {

      if (!config.mailbox_bottom_text) throw new Error("Unesite donji tekst.");

    } else if (config.product_type === "parking_notice") {

      if (!config.street) throw new Error("Unesite natpis.");

    } else if (config.product_type === "dog_notice") {

      if (!config.street) throw new Error("Unesite natpis.");

      if (!config.dog_symbol_key) throw new Error("Izaberite rasu / simbol psa.");

    } else if (config.product_type === "single_character") {

      const check = singleCharacterValidation(config.characters);

      if (!check.ok) throw new Error(check.message);

      if (!config.character_height_cm) throw new Error("Izaberite visinu karaktera.");

    } else if (config.product_type === "apartment_plate" && cfg.apartmentNatpisOnly) {
      if (!config.street) throw new Error("Unesite natpis.");
    } else if (config.product_type === "apartment_plate" && config.shape === "stan_plocica") {
      if (!config.street && !config.number) throw new Error("Unesite natpis ili broj.");
    } else if (!config.number || (!isNumberOnlyShape(config.shape) && !isStreetOptional(config) && !config.street)) {
      throw new Error((isNumberOnlyShape(config.shape) || isStreetOptional(config)) ? "Unesite broj." : "Unesite broj i natpis.");
    }
    if (config.product_type !== "single_character" && (!config.width_cm || !config.height_cm)) throw new Error("Dimenzija nije prepoznata.");

    await flowDeadline(ensureContactPhoneIdentified(config), 1500, "identity").catch(() => {});



    void postLeadEvent("table_design_started", {

      product_handle: cfg.productHandle || "",

      shape: config.shape,

      dimensions: `${config.width_cm}x${config.height_cm}`,

      number: config.number,

      street: config.street

    });

    flowStage = "render";
    const renderFiles = await buildRenderFiles(config);
    const payload = await buildPayload(config, renderFiles);
    if (operation) {
      payload.idempotency_key = operation.saveKey;
      payload.request_id = operation.requestId;
      payload.defer_preview_png = true;
    }
    flowStage = "save";

    const data = await flowFetch(cfg.saveUrl, {

      method: "POST",

      headers: {

        "Content-Type": "application/json",

        ...(cfg.ingestToken ? { "X-Lead-Ingest-Token": cfg.ingestToken } : {})

      },

      body: JSON.stringify(payload)

    }, "save", 20000);

    if (data.status !== "ok" || !data.design_id || !data.revision_id || !data.files?.preview_svg?.url || !data.combined_svg_url) {
      throw flowError("INVALID_RESPONSE", "save");
    }



    data._scene_preview_ready = renderFiles.scene_preview_ready === true;
    lastDesign = data;

    dirty = false;
    if (operation) { operation.design = data; persistFlowOperation(operation); }
    showAutosaveStatus("Dizajn je sačuvan", false);
    completeFlowPreview(operation, data);

    void postLeadEvent("table_design_saved", {

      design_id: data.design_id || "",

      preview_url: data.preview_url || "",

      product_handle: cfg.productHandle || "",

      shape: config.shape,

      dimensions: `${config.width_cm}x${config.height_cm}`,

      number: config.number,

      street: config.street

    });

    return data;

  }



  function renderPreview() {

    if (!syncValidationState(true)) {

      if (preview) preview.classList.remove("kb-preview-loading");

      return;

    }

    const config = currentConfig();
    const sequence = ++flowPreviewSequence;

    if (preview) preview.classList.add("kb-preview-loading");

    buildRenderFiles(config).then((renderFiles) => {

      if (sequence !== flowPreviewSequence) return;
      const svg = renderFiles.preview_svg || "";
      if (message && message.dataset.flowError === "preview") { setMessage("", ""); delete message.dataset.flowError; }

      if (preview) preview.innerHTML = svg;

      updateDimensionMarkers();

      fitInlinePreviewSvg();

      positionDimensionMarkers();

      syncGalleryPreview(svg);

    }).catch((err) => {
      if (sequence !== flowPreviewSequence || dodavanjeUToku) return;
      sendRenderErrorBeacon(err, config, "preview");
      showFlowError(Object.assign(err, { stage: "preview" }), false, null);
      if (message) message.dataset.flowError = "preview";
    })
      .finally(() => {

        if (preview && sequence === flowPreviewSequence) preview.classList.remove("kb-preview-loading");

      });

  }



  function schedulePreview() {

    dirty = true;

    if (!syncValidationState(false)) {

      clearTimeout(renderTimer);

      return;

    }

    clearTimeout(renderTimer);

    renderTimer = setTimeout(renderPreview, 150);

    scheduleDraftSave("change");

    scheduleAlternateShapes();

  }



  function isTextEntryField(el) {

    if (!el || el.tagName !== "INPUT") return false;

    const type = String(el.getAttribute("type") || "text").toLowerCase();

    return ["", "text", "search", "tel"].includes(type);

  }



  function textInsertTarget() {

    if (activeTextField && form && form.contains(activeTextField) && isTextEntryField(activeTextField)) {

      return activeTextField;

    }

    return form ? (form.querySelector('[name="characters"]') || form.querySelector('[name="street"]')) : null;

  }



  function insertTextAtCursor(input, text) {

    if (!input || !text) return;

    const value = String(input.value || "");

    const start = Number.isInteger(input.selectionStart) ? input.selectionStart : value.length;

    const end = Number.isInteger(input.selectionEnd) ? input.selectionEnd : start;

    input.value = value.slice(0, start) + text + value.slice(end);

    input.focus({ preventScroll: true });

    const nextPosition = start + text.length;

    if (typeof input.setSelectionRange === "function") input.setSelectionRange(nextPosition, nextPosition);

    notePrimaryTextInput(input, true);
    input.dispatchEvent(new Event("input", { bubbles: true }));

    schedulePreview();

  }



  // Dodavanje u korpu prvo cuva dizajn na CRM-u, pa tek onda zove cart/add.

  // Na slaboj vezi to traje par sekundi - bez vidljivog znaka kupac misli da

  // klik nije prosao i klikce ponovo.

  var dodavanjeUToku = false;



  function postaviZauzeto(zauzeto) {

    dodavanjeUToku = !!zauzeto;

    root.querySelectorAll("[data-kb-add], [data-kb-mobile-add], [data-kb-step-next]").forEach(function (b) {

      if (zauzeto) {

        if (b.dataset.kbTekstPre === undefined) b.dataset.kbTekstPre = b.innerHTML;

        b.innerHTML = '<span class="kb-busy-dot" aria-hidden="true"></span>Dodajem u korpu\u2026';

        b.classList.add("is-busy");

        b.disabled = true;

        b.setAttribute("aria-busy", "true");

      } else {

        if (b.dataset.kbTekstPre !== undefined) { b.innerHTML = b.dataset.kbTekstPre; delete b.dataset.kbTekstPre; }

        b.classList.remove("is-busy");

        b.disabled = false;

        b.removeAttribute("aria-busy");

      }

    });

    if (!zauzeto) syncWizardPrimaryAction();

  }



  async function addToCart() {

    if (dodavanjeUToku) return;   // zastita od dvostrukog klika

    setShareFallbackVisible(false);
    postaviZauzeto(true);
    const config = currentConfig();
    const variant = selectedVariant();
    const cartRoot = (window.Shopify && Shopify.routes ? Shopify.routes.root : "/");
    let operation = readFlowOperation();

    try {

      setMessage("Čuvam dizajn...", "loading");

      if (operation && ['dispatched', 'unknown', 'partial'].includes(operation.cartState) &&
          operation.fingerprint !== JSON.stringify([variant.id || selectedVariantId(), config])) {
        setMessage("Proveravamo da li je proizvod dodat u korpu…", "loading");
        await submitFlowCart(operation, { quantity: operation.quantity }, cartRoot, persistFlowOperation);
        reportFlowOutcome('table_design_flow_recovered', { stage: 'cart', code: 'CART_CONFIRMED' }, operation);
        clearLocalDraft();
        persistFlowOperation(null);
        window.location.href = flowPostCartDestination();
        return;
      }
      operation = newFlowOperation(config, variant.id || selectedVariantId());
      const design = operation.design || await saveDesign(config, operation);
      const visitor = visitorIdentity();
      flowStage = "cart";

      const designUrl = crmDesignUrl(design.design_id);

      const properties = {

        "Napomena": config.note,

        "Oblik": config.plate_shape,

        "Dimenzije": config.product_type === "single_character" ? `${displayCm(config.character_height_cm || config.height_cm)} cm` : `${config.width_cm} x ${config.height_cm} cm`,

        // Shopify ne cuva stavke redom dodavanja, pa stranica "Upotpunite dom"

        // ne moze da se osloni na cart.items.last. Ovim znamo sta je bas sad dodato.

        "_kb_ts": String(operation.timestamp),
        "_kb_add_attempt": operation.cartAttempt,

        "_design_id": design.design_id,

        "_crm_design_url": designUrl,

        "_preview_url": design.preview_url || "",
        "_preview_svg_url": design._scene_preview_ready ? (design.files?.preview_svg?.url || "") : "",

        "_combined_svg_url": design.combined_svg_url || "",

        "_lead_id": visitor.lead_id || "",

        "_anon_id": visitor.anon_id || "",

        "_session_id": visitor.session_id || ""

      };

      // Mesto sa scene („za sanduce", „za interfon") — ista plocica, razlicita
      // namena. Bez ovoga doprodajna stranica ne prepoznaje da je bas to vec
      // kupljeno, jer je u korpi obicna plocica.
      try {
        var kbMesto = new URLSearchParams(window.location.search).get("kb_mesto");
        if (kbMesto && /^[a-zA-Z]{1,30}$/.test(kbMesto)) properties["_kb_mesto"] = kbMesto;
      } catch (e) {}
      if (config.contact_phone) properties["Telefon"] = config.contact_phone;

      if (config.product_type === "apartment_plate") {

        properties["Materijal"] = selectedLabel("engraving_color") || config.engraving_color;
        // "Materijal" je naziv za kupca ("Srebrna graverska"), a prenos u drugi
        // konfigurator trazi vrednost ("srebrna_graverska"). Skriveno polje nosi
        // vrednost, da bi plocica za sanduce/interfon mogla da nasledi materijal.
        if (config.engraving_color) properties["_kb_engraving"] = config.engraving_color;

        properties["Prezime / natpis"] = config.street;

        if (config.number) properties["Broj"] = config.number;

        properties["Font"] = selectedLabel("plocica_font") || "Corsica MX";

        properties["Prikaz natpisa"] = config.text_case === "as_entered" ? "Kako je uneto" : "Sva velika slova";

        if (cfg.apartmentNatpisOnly) properties["Izgled pločice"] = config.plate_style === "rounded" ? "Zaobljena" : "Pravougaona";

        if (config.width_cm && config.height_cm) {

          properties["Dimenzije"] = `${displayCm(config.width_cm)} x ${displayCm(config.height_cm)} cm`;

        }

        if (customDimActive) {

          properties["Napomena"] = "Druga dimenzija — cena se prosleđuje nakon porudžbine";

        }

      } else if (config.product_type === "single_character") {

        properties["Karakteri"] = config.characters;

        properties["Broj karaktera"] = config.physical_character_count || physicalCharacterCount(config.characters);

        properties["Visina"] = `${displayCm(config.character_height_cm || config.height_cm)} cm`;

        properties["Font"] = selectedLabel("plocica_font") || "Corsica MX";

        properties["Boja / materijal"] = selectedLabel("text_color") || config.text_color;

        if (config.custom_height) {

          properties["Željena visina"] = `${displayCm(config.character_height_cm || config.height_cm)} cm`;

          properties["Napomena"] = "Neka druga visina - cena se potvrđuje nakon porudžbine";

        }

      } else {

        properties["Boja table"] = config.background_color;

        properties["Boja teksta"] = config.text_color;

      }

      if (config.distancer_color) properties["Distanceri"] = config.distancer_color;

      if (centerNumberShapes.has(config.shape)) {

        properties["Pozicija broja"] = config.number_align === "center" ? "Centar" : "Desno";

      }

      if (config.product_type === "video_notice") {

        properties["Gornji tekst"] = config.street;

        properties["Donji tekst"] = config.extra_text;

      } else if (config.product_type === "mailbox") {

        if (config.mailbox_top_text) properties["Gornji tekst"] = config.mailbox_top_text;

        properties["Donji tekst"] = config.mailbox_bottom_text;

        properties["Vrata"] = config.mailbox_door_color;

        properties["Sa strane"] = config.mailbox_side_color;

      } else if (config.product_type === "parking_notice") {

        properties["Natpis"] = config.street;

      } else if (config.product_type === "dog_notice") {

        const dog = dogSymbols.find((item) => item.key === config.dog_symbol_key);

        properties["Rasa psa"] = dog ? dog.label : config.dog_symbol_key;

        properties["Natpis"] = config.street;

      } else if (config.product_type !== "apartment_plate" && config.product_type !== "single_character") {

        properties["Broj"] = config.number;

      }

      if (config.product_type !== "apartment_plate" && !isNumberOnlyShape(config.shape) && !isTextOnlyShape(config.shape)) {

        if (config.street) properties["Natpis"] = config.street;

        if (config.extra_text) properties["Dodatni natpis"] = config.extra_text;

      }



      Object.assign(properties, window.KBUpsellAttribution?.properties(cfg.productHandle || "") || {});
      const cartResult = await submitFlowCart(operation, {
        id: Number(operation.variantId),
        quantity: config.product_type === "single_character" ? Math.max(1, config.physical_character_count || physicalCharacterCount(config.characters)) : 1,
        properties
      }, cartRoot, persistFlowOperation);
      if (cartResult.recovered) reportFlowOutcome('table_design_flow_recovered', { stage: 'cart', code: 'CART_CONFIRMED' }, operation);

      clearLocalDraft();
      persistFlowOperation(null);

      // Artikal je VEC u korpi. CRM dogadjaj je sporedan, pa ne sme ni da obori
      // ni da zadrzi preusmerenje na /cart - inace kupac vidi gresku za nesto sto je
      // uspelo i ostaje na mestu. Zato: greska se guta, ceka se najvise 2.5s.
      await Promise.race([
        postLeadEvent("table_design_add_to_cart", {

        design_id: design.design_id || "",

        crm_design_url: designUrl,

        preview_url: design.preview_url || "",

        product_handle: cfg.productHandle || "",

        variant_id: variant.id || selectedVariantId(),

        shape: config.shape,

        dimensions: `${config.width_cm}x${config.height_cm}`,

        number: config.number,

        street: config.street

        }).catch(function () {}),
        new Promise(function (resolve) { window.setTimeout(resolve, 2500); })
      ]);

      setMessage("Dodato u korpu.", "ok");

      // Normal and recovered additions continue to the requested product suggestions page.

      window.location.href = flowPostCartDestination();

    } catch (err) {

      postaviZauzeto(false);

      const code = err.code || (flowStage === 'validation' ? 'VALIDATION_ERROR' :
        /font.*(podrzava|podržava)/i.test(err.message || '') ? 'FONT_UNSUPPORTED' : err instanceof TypeError ? 'NETWORK' : 'UNEXPECTED');
      showFlowError(Object.assign(err, { code, stage: err.stage || flowStage }), Boolean(operation && operation.design), operation);
      setShareFallbackVisible(true);

    }

  }



  function syncDistancerDefault() {

    const textSelect = form ? form.querySelector('[name="text_color"]') : null;

    const distancerSelect = form ? form.querySelector('[name="distancer_color"]') : null;

    if (!textSelect || !distancerSelect) return;

    if (textSelect.value.indexOf("zlatno_ogledalo") === 0 && distancerSelect.value === "srebrna") {

      distancerSelect.value = "zlatna";

    } else if (textSelect.value.indexOf("srebrno_ogledalo") === 0 && distancerSelect.value === "zlatna") {

      distancerSelect.value = "srebrna";

    }

  }



  function isMailboxMirrorTextLocked() {

    const shape = cfg.renderShape || root.dataset.renderShape || "";

    return shape === "postansko_sanduce" && MAILBOX_MIRROR_PLATE_COLORS.has(field("plate_color"));

  }



  function syncMailboxMirrorTextLock() {

    if (!form) return false;

    const locked = isMailboxMirrorTextLocked();

    const textSelect = form.querySelector('[name="text_color"]');

    if (textSelect) {

      if (locked && textSelect.value !== "siva") textSelect.value = "siva";

      textSelect.disabled = locked;

      textSelect.title = locked ? "Boja teksta je zaključana kada su pločice ogledalo." : "";

    }

    root.querySelectorAll('[data-kb-swatch-select="text_color"]').forEach((button) => {

      button.disabled = locked;

      button.classList.toggle("is-disabled", locked);

      button.setAttribute("aria-disabled", locked ? "true" : "false");

      button.title = locked ? "Boja teksta je zaključana kada su pločice ogledalo." : (button.getAttribute("aria-label") || "");

    });

    return locked;

  }




  // Text-only sharing stays available without saving a design on the CRM.
  function formatWhatsAppSelection(config, details) {
    const labels = details.labels || {};
    const clean = (value) => String(value == null ? "" : value).trim();
    const lines = ["Zdravo! Želim da naručim sledeći proizvod:"];
    const add = (label, value) => { if (clean(value)) lines.push(label + ": " + clean(value)); };
    const colorNames = {
      crna: "Crna", bela: "Bela", siva: "Siva", antracit: "Antracit",
      srebrno_ogledalo: "Srebrno ogledalo", zlatno_ogledalo: "Zlatno ogledalo",
      srebrna_graverska: "Srebrna graverska", zlatna_graverska: "Zlatna graverska",
      crna_graverska: "Crna graverska", drvo_dezen: "Drvo dezen",
      cesljano_srebro: "Češljano srebro", srebrna: "Srebrna", zlatna: "Zlatna"
    };
    const color = (key, label) => colorNames[key] || label || key;
    const cm = (value) => clean(value).replace(".", ",");
    const inscription = (value) => config.text_case === "uppercase" ? clean(value).toUpperCase() : clean(value);
    add("Proizvod", details.productTitle);
    add("Oblik", details.shapeLabel || config.shape);
    if (config.product_type === "single_character") {
      add("Visina", cm(config.character_height_cm || config.height_cm) + " cm");
      add("Karakteri", config.characters);
      add("Broj karaktera", config.physical_character_count || details.characterCount);
      add("Boja / materijal", color(config.text_color, labels.text_color));
    } else {
      if (config.width_cm && config.height_cm) add("Dimenzije", cm(config.width_cm) + " × " + cm(config.height_cm) + " cm");
      if (config.product_type === "apartment_plate") {
        add("Materijal", labels.engraving_color || color(config.engraving_color));
        add("Natpis", inscription(config.street));
        add("Broj", config.number);
        if (details.apartmentNatpisOnly) add("Izgled pločice", config.plate_style === "rounded" ? "Zaobljena" : "Pravougaona");
      } else {
        add("Boja table / pločice", color(config.background_color, labels.plate_color));
        add("Boja teksta", color(config.text_color, labels.text_color));
        if (config.product_type === "mailbox") {
          add("Vrata sandučeta", labels.mailbox_door_color || color(config.mailbox_door_color));
          add("Stranice sandučeta", labels.mailbox_side_color || color(config.mailbox_side_color));
          add("Gornja pločica", config.mailbox_has_top_plate ? "Da" : "Ne");
          add("Gornji natpis", config.mailbox_top_text);
          add("Donji natpis", config.mailbox_bottom_text);
        } else {
          add(config.product_type === "video_notice" ? "Gornji natpis" : "Natpis", inscription(config.street));
          add(config.product_type === "video_notice" ? "Donji natpis" : "Dodatni natpis", inscription(config.extra_text));
          add("Broj", config.number);
          if (config.product_type === "dog_notice") add("Rasa / simbol psa", details.dogLabel || config.dog_symbol_key);
        }
      }
    }
    if (config.distancer_color) add("Distanceri", labels.distancer_color || color(config.distancer_color));
    if (details.numberPosition) add("Pozicija broja", details.numberPosition);
    add("Pismo", { latin: "Latinica", cyrillic: "Ćirilica", as_entered: "Kako je uneto" }[config.script] || labels.script || config.script);
    if (config.plocica_font) add("Font", labels.plocica_font || config.plocica_font);
    if (config.product_type === "apartment_plate") add("Prikaz natpisa", config.text_case === "as_entered" ? "Kako je uneto" : "Sva velika slova");
    add("Količina", config.product_type === "single_character" ? "1 komplet navedenih karaktera" : "1 komad");
    if (details.customDimensions || config.custom_height) add("Posebna dimenzija", "Da — cenu je potrebno potvrditi");
    add("Napomena", config.note);
    add("Kontakt telefon", config.contact_phone);
    add("Link proizvoda", details.productUrl);
    return lines.join("\n");
  }

  function currentSelectionMessage() {
    const config = currentConfig();
    const variant = selectedVariant();
    const labels = {};
    ["plate_color", "text_color", "distancer_color", "engraving_color", "mailbox_door_color", "mailbox_side_color", "plocica_font", "script"].forEach((name) => {
      labels[name] = selectedLabel(name);
    });
    const dog = dogSymbols.find((item) => item.key === config.dog_symbol_key);
    const productUrl = new URL(window.location.pathname, window.location.origin);
    if (variant.id) productUrl.searchParams.set("variant", variant.id);
    const text = formatWhatsAppSelection(config, {
      labels,
      productTitle: cfg.productTitle || document.querySelector("h1")?.textContent.trim() || cfg.productHandle,
      shapeLabel: shapeLabels[config.shape],
      apartmentNatpisOnly: cfg.apartmentNatpisOnly,
      characterCount: config.product_type === "single_character" ? physicalCharacterCount(config.characters) : 0,
      dogLabel: dog && dog.label,
      numberPosition: centerNumberShapes.has(config.shape) ? (config.number_align === "center" ? "Centar" : "Desno") : "",
      customDimensions: customDimActive,
      productUrl: productUrl.href
    });
    return text;
  }

  function setShareFallbackVisible(visible) {
    root.querySelectorAll("[data-kb-share-error]").forEach((group) => {
      group.hidden = !visible;
    });
  }

  function initWhatsAppSharing() {
    const links = root.querySelectorAll("[data-kb-whatsapp-share], [data-kb-email-share]");
    function refresh() {
      try {
        const text = currentSelectionMessage();
        const whatsappUrl = "https://wa.me/381658416212?text=" + encodeURIComponent(text);
        const emailUrl = "mailto:goodsigndoo@gmail.com?subject=" + encodeURIComponent("Upit za proizvod — " + (cfg.productTitle || cfg.productHandle || "Kućni brojevi")) + "&body=" + encodeURIComponent(text);
        links.forEach((link) => { link.href = link.hasAttribute("data-kb-email-share") ? emailUrl : whatsappUrl; });
        return true;
      } catch (error) { return false; }
    }
    links.forEach((link) => {
      link.addEventListener("click", (event) => {
        transliterateAllFields();
        if (!refresh()) {
          event.preventDefault();
          if (message) message.textContent = "Poruku trenutno ne možemo da pripremimo. Pokušajte ponovo.";
        }
      });
      link.addEventListener("focus", refresh);
      link.addEventListener("pointerdown", refresh);
      link.addEventListener("contextmenu", refresh);
    });
    if (form) {
      form.addEventListener("input", refresh);
      form.addEventListener("change", refresh);
    }
    if (variantInput) variantInput.addEventListener("change", refresh);
    refresh();
  }

  function selectedLabel(name) {

    const select = form ? form.querySelector(`[name="${name}"]`) : null;

    if (!select) return "";

    const option = select.options[select.selectedIndex];

    return option ? option.textContent.trim() : select.value;

  }



  function updateSelectionSummary() {

    if (!selectionSummary) return;

    const config = currentConfig();

    const plate = selectedLabel("plate_color");

    const text = selectedLabel("text_color");

    const distancer = selectedLabel("distancer_color");

    const align = centerNumberShapes.has(config.shape) ? (config.number_align === "center" ? "broj centar" : "broj desno") : "";

    const dimensions = config.width_cm && config.height_cm ? `${config.width_cm} x ${config.height_cm} cm` : "dimenzija iz proizvoda";

    const shape = shapeLabels[config.shape] || config.shape || "Oblik";

    const alignPart = align ? ` | <strong>${escapeHtml(align)}</strong>` : "";

    if (config.product_type === "apartment_plate") {

      const style = cfg.apartmentNatpisOnly ? ` | izgled: <strong>${config.plate_style === "rounded" ? "Zaobljena" : "Pravougaona"}</strong>` : "";

      selectionSummary.innerHTML = `<span>Trenutno: <strong>${escapeHtml(dimensions)}</strong> | <strong>${escapeHtml(shape)}</strong> | materijal: <strong>${escapeHtml(selectedLabel("engraving_color"))}</strong>${style}</span>`;

      return;

    }

    if (config.product_type === "single_character") {

      const count = config.physical_character_count || physicalCharacterCount(config.characters);

      selectionSummary.innerHTML = `<span>Trenutno: <strong>${escapeHtml(displayCm(config.character_height_cm || config.height_cm))} cm</strong> | <strong>${escapeHtml(shape)}</strong> | karaktera: <strong>${escapeHtml(count)}</strong> | materijal: <strong>${escapeHtml(selectedLabel("text_color"))}</strong></span>`;

      return;

    }

    if (config.product_type === "mailbox") {

      selectionSummary.innerHTML = `<span>Trenutno: <strong>19,4 x 29,6 cm</strong> | <strong>${escapeHtml(shape)}</strong> | pločice: <strong>${escapeHtml(plate)}</strong> | tekst: <strong>${escapeHtml(text)}</strong></span>`;

      return;

    }

    if (isTextOnlyShape(config.shape)) {

      selectionSummary.innerHTML = `<span>Trenutno: <strong>${escapeHtml(dimensions)}</strong> | <strong>${escapeHtml(shape)}</strong> | tabla: <strong>${escapeHtml(plate)}</strong> | tekst: <strong>${escapeHtml(text)}</strong> | distanceri: <strong>${escapeHtml(distancer)}</strong></span>`;

      return;

    }

    selectionSummary.innerHTML = `<span>Trenutno: <strong>${escapeHtml(dimensions)}</strong> | <strong>${escapeHtml(shape)}</strong>${alignPart} | tabla: <strong>${escapeHtml(plate)}</strong> | tekst: <strong>${escapeHtml(text)}</strong> | distanceri: <strong>${escapeHtml(distancer)}</strong></span>`;

  }



  function updateNumberAlignState() {

    if (!form) return;

    const shape = cfg.renderShape || root.dataset.renderShape || "standard";

    const supported = centerNumberShapes.has(shape);

    const select = form.querySelector('[name="number_align"]');

    root.querySelectorAll("[data-kb-number-align-field]").forEach((fieldEl) => {

      fieldEl.hidden = !supported;

    });

    if (select && !supported && select.value !== "right") {

      select.value = "right";

    }

    root.querySelectorAll("[data-kb-number-align]").forEach((button) => {

      button.setAttribute("aria-pressed", select && select.value === button.dataset.kbNumberAlign ? "true" : "false");

    });

  }



  function updateScriptState() {

    if (!form) return;

    const select = form.querySelector('[name="script"]');

    root.querySelectorAll("[data-kb-script-select]").forEach((button) => {

      button.setAttribute("aria-pressed", select && select.value === button.dataset.kbScriptSelect ? "true" : "false");

    });

  }



  function updateTextCaseState() {

    if (!form) return;

    const select = form.querySelector('[name="text_case"]');

    const current = select ? (select.value || "uppercase") : "uppercase";

    root.querySelectorAll("[data-kb-text-case]").forEach((button) => {

      button.setAttribute("aria-pressed", current === button.dataset.kbTextCase ? "true" : "false");

    });

  }



  function updatePlateStyleState() {

    if (!form) return;

    const select = form.querySelector('[name="plate_style"]');

    const current = select ? (select.value || "rectangular") : "rectangular";

    root.querySelectorAll("[data-kb-plate-style]").forEach((button) => {

      button.setAttribute("aria-pressed", current === button.dataset.kbPlateStyle ? "true" : "false");

    });

  }



  function updateCartCheck() {

    if (!cartCheck) return;

    const config = currentConfig();

    const street = config.street || "natpis";

    const number = config.number || "broj";

    if (config.product_type === "video_notice") {

      const bottom = config.extra_text || "";

      cartCheck.innerHTML = `<strong>${escapeHtml(street)}</strong>${bottom ? ` <strong>${escapeHtml(bottom)}</strong>` : ""} - ${escapeHtml(selectedLabel("plate_color"))} + ${escapeHtml(selectedLabel("text_color"))}`;

      return;

    }

    if (config.product_type === "parking_notice") {

      cartCheck.innerHTML = `<strong>${escapeHtml(street)}</strong> - ${escapeHtml(selectedLabel("plate_color"))} + ${escapeHtml(selectedLabel("text_color"))}`;

      return;

    }

    if (config.product_type === "mailbox") {

      const top = config.mailbox_top_text ? `<strong>${escapeHtml(config.mailbox_top_text)}</strong> ` : "";

      cartCheck.innerHTML = `${top}<strong>${escapeHtml(config.mailbox_bottom_text || "")}</strong> - ${escapeHtml(selectedLabel("plate_color"))} + ${escapeHtml(selectedLabel("text_color"))}`;

      return;

    }

    if (config.product_type === "dog_notice") {

      const dog = dogSymbols.find((item) => item.key === config.dog_symbol_key);

      cartCheck.innerHTML = `<strong>${escapeHtml(street)}</strong>${dog ? ` · ${escapeHtml(dog.label)}` : ""} - ${escapeHtml(selectedLabel("plate_color"))} + ${escapeHtml(selectedLabel("text_color"))}`;

      return;

    }

    if (config.product_type === "apartment_plate") {

      cartCheck.innerHTML = cfg.apartmentNatpisOnly

        ? `<strong>${escapeHtml(street)}</strong> - ${escapeHtml(selectedLabel("engraving_color"))}`

        : `<strong>${escapeHtml(street)}</strong> <strong>${escapeHtml(number)}</strong> - ${escapeHtml(selectedLabel("engraving_color"))}`;

      return;

    }

    if (config.product_type === "single_character") {

      const count = config.physical_character_count || physicalCharacterCount(config.characters);

      cartCheck.innerHTML = `<strong>${escapeHtml(config.characters || "karakteri")}</strong> · ${escapeHtml(count)} kom. · ${escapeHtml(displayCm(config.character_height_cm || config.height_cm))} cm - ${escapeHtml(selectedLabel("text_color"))}`;

      return;

    }

    if (isNumberOnlyShape(config.shape) || !street) {

      cartCheck.innerHTML = `<strong>${escapeHtml(number)}</strong> - ${escapeHtml(selectedLabel("plate_color"))} + ${escapeHtml(selectedLabel("text_color"))}`;

      return;

    }

    cartCheck.innerHTML = `<strong>${escapeHtml(street)}</strong> <strong>${escapeHtml(number)}</strong> - ${escapeHtml(selectedLabel("plate_color"))} + ${escapeHtml(selectedLabel("text_color"))}`;

  }



  /* --- Privremeno nedostupne boje -------------------------------
     Spisak dolazi iz snippeta (data-unavailable-colors). Boja se NE uklanja
     iz izbora nego ostaje vidljiva i zatamnjena, sa objasnjenjem — inace
     kupcu boja nestane bez razloga. Klik na nju nudi zamenu.
     Prazan atribut = sve dostupno, ceo mehanizam miruje. */
  var NEDOSTUPNE = String(root.dataset.unavailableColors || "")
    .split(",").map(function (x) { return x.trim(); }).filter(Boolean);
  var ZAMENA = String(root.dataset.colorFallback || "crna").trim();
  var ZAMENA_NAZIV = String(root.dataset.colorFallbackLabel || "Crna").trim();
  /* Akuzativ, da poruka ne glasi „Izabrali smo Crna". Snippet ga zadaje;
     ako nije zadat, pravimo ga iz naziva (Crna -> Crnu, Siva -> Sivu). */
  var ZAMENA_AKUZATIV = String(root.dataset.colorFallbackAccusative || "").trim()
    || ZAMENA_NAZIV.replace(/a$/, "u");
  var BOJA_POLJA = ["plate_color", "text_color", "distancer_color", "engraving_color"];

  function jeNedostupna(v) {
    return NEDOSTUPNE.length > 0 && NEDOSTUPNE.indexOf(String(v || "")) !== -1;
  }

  function nazivBoje(v) {
    var opt = form && form.querySelector('option[value="' + v + '"]');
    return opt ? opt.textContent.replace(/\s*—.*$/, "").trim() : v;
  }

  /* Sacuvan nacrt, preset ili URL mogu doneti nedostupnu boju — prebaci je. */
  function zameniNedostupneBoje(tiho) {
    if (!form || !NEDOSTUPNE.length) return false;
    var promenjeno = null;
    BOJA_POLJA.forEach(function (name) {
      var sel = form.querySelector('[name="' + name + '"]');
      if (!sel || !jeNedostupna(sel.value)) return;
      promenjeno = nazivBoje(sel.value);
      sel.value = ZAMENA;
      sel.dispatchEvent(new Event("change", { bubbles: true }));
    });
    if (promenjeno && !tiho) {
      setMessage(promenjeno + " je trenutno rasprodat — prebacili smo na " + ZAMENA_AKUZATIV + ".", "info");
    }
    return !!promenjeno;
  }

  function oznaciNedostupneBoje() {
    if (!form || !NEDOSTUPNE.length) return;
    BOJA_POLJA.forEach(function (name) {
      var sel = form.querySelector('[name="' + name + '"]');
      if (!sel) return;
      sel.querySelectorAll("option").forEach(function (opt) {
        if (!jeNedostupna(opt.value)) return;
        opt.disabled = true;
        if (!/nedostupno/i.test(opt.textContent)) opt.textContent += " — trenutno nedostupno";
      });
    });
    root.querySelectorAll("[data-kb-swatch-select]").forEach(function (btn) {
      if (!jeNedostupna(btn.dataset.kbSwatchValue)) return;
      btn.classList.add("is-unavailable");
      btn.setAttribute("aria-disabled", "true");
      var naziv = btn.getAttribute("title") || "Ova boja";
      if (!/nedostupno/i.test(naziv)) btn.setAttribute("title", naziv + " — trenutno nedostupno");
    });

  }

  /* Napomena se NE prikazuje unapred — pojavljuje se tek kad kupac pokusa da
     izabere nedostupnu boju, i to odmah ispod tog reda uzoraka. Na telefonu
     nema hovera pa `title` niko ne vidi, a poruka u traci zna da bude van
     ekrana; ovako objasnjenje stoji tacno tamo gde je kliknuo.
     Sama se sklanja posle 6 sekundi ili cim izabere drugu boju. */
  var napomenaTajmeri = {};

  function prikaziNapomenuNedostupno(polje, boja) {
    var grupa = root.querySelector('[data-kb-swatch-options="' + polje + '"]');
    if (!grupa) return;
    var nota = grupa.parentNode.querySelector("[data-kb-unavailable-note]");
    if (!nota) {
      nota = document.createElement("div");
      nota.className = "kb-unavailable-note";
      nota.setAttribute("data-kb-unavailable-note", "");
      nota.setAttribute("role", "status");
      grupa.insertAdjacentElement("afterend", nota);
    }
    var naziv = nazivBoje(boja);
    nota.innerHTML =
      '<span class="kb-un-dot" style="--kb-un-fill:' + (swatchFills[boja] || "#383E42") + '"></span>'
      + '<span class="kb-un-txt">'
      +   '<strong>' + escapeHtml(naziv) + ' je trenutno rasprodat.</strong> '
      +   'Prebacili smo na <strong>' + escapeHtml(ZAMENA_AKUZATIV) + '</strong> — najbliže je po izgledu.'
      + '</span>';
    /* restart animacije kad se ista napomena pozove ponovo */
    nota.classList.remove("is-visible");
    void nota.offsetWidth;
    nota.classList.add("is-visible");
    clearTimeout(napomenaTajmeri[polje]);
    napomenaTajmeri[polje] = setTimeout(function () { sakrijNapomenu(polje); }, 7000);
  }

  function sakrijNapomenu(polje) {
    var grupa = root.querySelector('[data-kb-swatch-options="' + polje + '"]');
    var nota = grupa && grupa.parentNode.querySelector("[data-kb-unavailable-note]");
    if (nota) nota.classList.remove("is-visible");
    clearTimeout(napomenaTajmeri[polje]);
  }

  function updateSwatches() {

    if (!form) return;

    syncMailboxMirrorTextLock();

    root.querySelectorAll("[data-kb-swatch-select]").forEach((button) => {

      const name = button.dataset.kbSwatchSelect;

      const value = button.dataset.kbSwatchValue || "";

      const select = form.querySelector(`[name="${name}"]`);

      button.style.setProperty("--kb-swatch-fill", swatchFills[value] || "#030303");

      button.setAttribute("aria-pressed", select && select.value === value ? "true" : "false");

    });

    root.querySelectorAll("[data-kb-selected-label]").forEach((label) => {

      label.textContent = selectedLabel(label.dataset.kbSelectedLabel);

    });

    root.querySelectorAll("[data-kb-color-combo]").forEach((button) => {

      const parts = String(button.dataset.kbColorCombo || "").split("|");

      button.style.setProperty("--kb-combo-left", comboSolidFills[parts[0]] || "#030303");

      button.style.setProperty("--kb-combo-right", comboSolidFills[parts[1]] || "#cfd5da");

      button.setAttribute("aria-pressed",

        field("plate_color") === parts[0] && field("text_color") === parts[1] && field("distancer_color") === parts[2] ? "true" : "false"

      );

    });

    updateNumberAlignState();

    updateScriptState();

    updateTextCaseState();

    updatePlateStyleState();

    updateSelectionSummary();

    updateCartCheck();

    updateContrastWarning();

    updateDimensionMarkers();

    updateDimensionControls();

    updatePrice();

  }



  function setPreviewMode(mode) {

    const next = mode === "facade" ? "facade" : "clean";

    if (preview) preview.dataset.previewMode = next;

    root.classList.toggle("kb-preview-facade-active", next === "facade");

    root.querySelectorAll("[data-kb-preview-mode]").forEach((button) => {

      button.setAttribute("aria-pressed", button.dataset.kbPreviewMode === next ? "true" : "false");

    });

  }



  function setFacadeBackground(background) {

    const next = ["dark", "concrete"].includes(background) ? background : "light";

    if (preview) preview.dataset.facadeBg = next;

    root.querySelectorAll("[data-kb-facade-bg]").forEach((button) => {

      button.setAttribute("aria-pressed", button.dataset.kbFacadeBg === next ? "true" : "false");

    });

  }



  if (form) {

    const rememberTextField = (event) => {

      if (isTextEntryField(event.target)) activeTextField = event.target;

      if (event.target && (isTextEntryField(event.target) || event.target.closest("[data-kb-swatch-select], [data-kb-color-combo], [data-kb-script-select], [data-kb-number-align], [data-kb-dog-symbol-key]"))) {

        activateGalleryPreview();

        const currentSvg = preview ? preview.innerHTML : "";

        if (currentSvg) syncGalleryPreview(currentSvg);

      }

    };

    form.addEventListener("focusin", (event) => {
      rememberTextField(event);
      reportConfiguratorOpened("field_focus");
    });

    form.addEventListener("click", rememberTextField);

    form.addEventListener("pointerdown", rememberTextField);

    form.addEventListener("input", (event) => {

      notePrimaryTextInput(event.target, event.isTrusted === true);
      activateGalleryPreview();

      if (event.target && textFields().includes(event.target)) scheduleFieldTransliteration(event.target);

      if (event.target && event.target.name === "contact_phone") scheduleContactPhoneIdentify();

      updateCartCheck();

      updateFontSamples();

      syncValidationState(true);

      schedulePreview();

    });

  }

  if (form) form.addEventListener("change", (event) => {

    activateGalleryPreview();

    if (event.target && event.target.name === "text_color") syncDistancerDefault();

    if (event.target && event.target.name === "script") transliterateAllFields();

    syncMailboxMirrorTextLock();

    updateSwatches();

    updateFontSamples();

    schedulePreview();

  });

  root.querySelectorAll("[data-kb-swatch-select]").forEach((button) => {
    button.addEventListener("click", () => {
      if (!form) return;
      if (button.dataset.kbSwatchSelect === "text_color" && isMailboxMirrorTextLocked()) return;
      /* Jedan klik: objasni i odmah ponudi zamenu. Dupli klik bi bio zbunjujuć
         na uzorku koji je vizuelno precrtan. */
      if (jeNedostupna(button.dataset.kbSwatchValue)) {
        var polje0 = button.dataset.kbSwatchSelect;
        var sel0 = form.querySelector('[name="' + polje0 + '"]');
        if (sel0 && sel0.value !== ZAMENA) {
          sel0.value = ZAMENA;
          sel0.dispatchEvent(new Event("change", { bubbles: true }));
          updateSwatches();
        }
        prikaziNapomenuNedostupno(polje0, button.dataset.kbSwatchValue);
        return;
      }
      sakrijNapomenu(button.dataset.kbSwatchSelect);
      const select = form.querySelector(`[name="${button.dataset.kbSwatchSelect}"]`);

      if (!select) return;

      select.value = button.dataset.kbSwatchValue || "";

      select.dispatchEvent(new Event("change", { bubbles: true }));

      updateSwatches();
    });
  });
  const chipFontPromises = new Map();

  function loadFontChipPreview(button) {
    if (!button || !button.dataset.kbFontFamily || !button.dataset.kbFontUrl) return Promise.resolve(false);
    const family = button.dataset.kbFontFamily;
    if (chipFontPromises.has(family)) return chipFontPromises.get(family);
    if (!("FontFace" in window) || !document.fonts) return Promise.resolve(false);
    const font = new FontFace(family, `url(${button.dataset.kbFontUrl})`, {
      display: "swap",
      style: "normal",
      weight: "400"
    });
    const promise = font.load()
      .then((loaded) => {
        document.fonts.add(loaded);
        root.querySelectorAll(`[data-kb-font-family="${family}"]`).forEach((chip) => {
          chip.classList.add("is-font-loaded");
        });
        return true;
      })
      .catch(() => false);
    chipFontPromises.set(family, promise);
    return promise;
  }

  function initFontChipLazyLoading() {
    const chips = Array.from(root.querySelectorAll("[data-kb-font-chip]"));
    if (!chips.length) return;
    chips.filter((chip) => chip.getAttribute("aria-pressed") === "true").forEach((chip) => {
      loadFontChipPreview(chip);
    });
    if (!("IntersectionObserver" in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadFontChipPreview(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: "160px 0px" });
    chips.forEach((chip) => observer.observe(chip));
  }

  function updateFontSamples() {
    const samples = root.querySelectorAll(".kb-font-sample");
    if (!samples.length || !form) return;
    const raw = ((isSingleCharacterShape(cfg.renderShape || root.dataset.renderShape || "standard") ? field("characters") : field("street")) || "").trim();

    let sample = raw || "Aa Ћћ 123";

    if (raw && field("text_case") !== "as_entered") {

      sample = raw.toLocaleUpperCase("sr-RS");

    }

    samples.forEach((el) => { el.textContent = sample; });

  }

  function syncFontChips() {

    if (!form) return;

    const select = form.querySelector('[name="plocica_font"]');

    const current = select ? select.value || "" : "";

    root.querySelectorAll("[data-kb-font-chip]").forEach((b) => {

      b.setAttribute("aria-pressed", (b.dataset.kbFontChip || "") === current ? "true" : "false");

    });

  }

  root.querySelectorAll("[data-kb-font-chip]").forEach((button) => {

    button.addEventListener("click", () => {

      if (!form) return;

      const select = form.querySelector('[name="plocica_font"]');

      if (!select) return;
      select.value = button.dataset.kbFontChip || "";
      loadFontChipPreview(button);
      syncFontChips();
      select.dispatchEvent(new Event("change", { bubbles: true }));
      schedulePreview();
    });
  });
  initFontChipLazyLoading();
  syncFontChips();
  updateFontSamples();
  (function preloadEngravingTextures() {

    const map = window.KB_TABLE_RENDERER_ASSETS || {};

    ["materials/cesljano_srebro.png", "materials/cesljano_zlato.png"].forEach((key) => {

      const url = map[key];

      if (!url) return;

      const img = new Image();

      img.onload = () => { schedulePreview(); };

      img.src = url;

    });

  })();

  root.querySelectorAll("[data-kb-color-combo]").forEach((button) => {

    button.addEventListener("click", () => {

      if (!form) return;

      const parts = String(button.dataset.kbColorCombo || "").split("|");

      const plate = form.querySelector('[name="plate_color"]');

      const text = form.querySelector('[name="text_color"]');

      const distancer = form.querySelector('[name="distancer_color"]');

      if (plate && parts[0]) plate.value = parts[0];

      if (text && parts[1]) text.value = parts[1];

      if (distancer && parts[2]) distancer.value = parts[2];

      zameniNedostupneBoje(true);
      syncMailboxMirrorTextLock();

      updateSwatches();

      schedulePreview();

      postLeadEvent("table_design_color_preset_click", {

        product_handle: cfg.productHandle || "",

        preset: button.dataset.kbPresetLabel || button.textContent || "",

        plate_color: parts[0] || "",

        text_color: parts[1] || "",

        distancer_color: parts[2] || ""

      }).catch(() => {});

    });

  });

  root.querySelectorAll("[data-kb-contrast-fix]").forEach((button) => {

    button.addEventListener("click", () => {

      applyBetterContrast();

    });

  });

  if (alternateShapesGrid) {

    alternateShapesGrid.addEventListener("click", (event) => {

      const link = event.target && event.target.closest("[data-kb-alternate-shape]");

      if (!link || !alternateShapesGrid.contains(link)) return;

      const config = currentConfig();

      postLeadEvent("table_design_alternate_shape_click", {

        source_product_handle: cfg.productHandle || "",

        target: link.dataset.kbAlternateShape || "",

        target_label: link.dataset.kbAlternateLabel || "",

        product_type: config.product_type || "",

        dimensions: `${config.width_cm || ""}x${config.height_cm || ""}`,

        has_street: !!config.street,

        has_number: !!config.number,

        has_extra_text: !!config.extra_text

      }).catch(() => {});

    });

  }

  root.querySelectorAll("[data-kb-number-align]").forEach((button) => {

    button.addEventListener("click", () => {

      if (!form) return;

      const select = form.querySelector('[name="number_align"]');

      if (!select) return;

      select.value = button.dataset.kbNumberAlign === "center" ? "center" : "right";

      updateSwatches();

      schedulePreview();

    });

  });

  if (dimensionOptions) {

    dimensionOptions.addEventListener("click", (event) => {

      const customBtn = event.target.closest("[data-kb-dimension-custom]");

      if (customBtn && dimensionOptions.contains(customBtn)) {

        if (!activateCustomDimension()) return;

        updateSwatches();

        updatePrice();

        schedulePreview();

        scheduleAlternateShapes();

        return;

      }

      const button = event.target.closest("[data-kb-dimension-choice]");

      if (!button || !dimensionOptions.contains(button)) return;

      const shape = cfg.renderShape || root.dataset.renderShape || "standard";

      const changed = isSingleCharacterShape(shape)

        ? selectVariantByCharacterHeight(button.dataset.kbDimensionHeight)

        : selectVariantByDimension(button.dataset.kbDimensionWidth, button.dataset.kbDimensionHeight);

      if (!changed) return;

      deactivateCustomDimension();

      updateSwatches();

      updatePrice();

      schedulePreview();

      scheduleAlternateShapes();

    });

  }

  if (customWidthInput || customHeightInput) {

    [customWidthInput, customHeightInput].forEach((inp) => {

      if (!inp) return;

      inp.addEventListener("input", () => {

        if (!customDimActive) return;

        updateDimensionControls();

        updateSelectionSummary();

        updateCartCheck();

        schedulePreview();

      });

    });

  }

  if (dogSymbolSearch) {

    dogSymbolSearch.addEventListener("input", () => {

      renderDogSymbolGrid(dogSymbolSearch.value);

    });

  }

  if (dogSymbolGrid) {

    dogSymbolGrid.addEventListener("click", (event) => {

      const button = event.target.closest("[data-kb-dog-symbol-key]");

      if (!button || !dogSymbolGrid.contains(button)) return;

      setField("dog_symbol_key", button.dataset.kbDogSymbolKey || "lovacki_01");

      renderDogSymbolGrid(dogSymbolSearch ? dogSymbolSearch.value : "");

      updateCartCheck();

      activateGalleryPreview();

      schedulePreview();

    });

  }

  root.querySelectorAll("[data-kb-script-select]").forEach((button) => {

    button.addEventListener("click", () => {

      if (!form) return;

      const select = form.querySelector('[name="script"]');

      if (!select) return;

      select.value = button.dataset.kbScriptSelect || "cyrillic";

      select.dispatchEvent(new Event("change", { bubbles: true }));

      updateSwatches();

      schedulePreview();

    });

  });

  root.querySelectorAll("[data-kb-text-case]").forEach((button) => {

    button.addEventListener("click", () => {

      if (!form) return;

      const select = form.querySelector('[name="text_case"]');

      if (!select) return;

      select.value = button.dataset.kbTextCase === "as_entered" ? "as_entered" : "uppercase";

      select.dispatchEvent(new Event("change", { bubbles: true }));

      updateTextCaseState();

      updateFontSamples();

      schedulePreview();

    });

  });

  root.querySelectorAll("[data-kb-plate-style]").forEach((button) => {

    button.addEventListener("click", () => {

      if (!form) return;

      const select = form.querySelector('[name="plate_style"]');

      if (!select) return;

      select.value = button.dataset.kbPlateStyle === "rounded" ? "rounded" : "rectangular";

      select.dispatchEvent(new Event("change", { bubbles: true }));

      updatePlateStyleState();

      updateSelectionSummary();

      updateCartCheck();

      schedulePreview();

    });

  });

  root.querySelectorAll("[data-kb-preview-mode]").forEach((button) => {

    button.addEventListener("click", () => {

      setPreviewMode(button.dataset.kbPreviewMode);

    });

  });

  root.querySelectorAll("[data-kb-facade-bg]").forEach((button) => {

    button.addEventListener("click", () => {

      setFacadeBackground(button.dataset.kbFacadeBg);

      setPreviewMode("facade");

    });

  });

  root.querySelectorAll("[data-kb-step-jump]").forEach((button) => {

    button.addEventListener("click", () => {

      scrollToStep(button.dataset.kbStepJump || "text");

    });

  });

  root.querySelectorAll("[data-kb-step-prev]").forEach((button) => {

    button.addEventListener("click", () => {

      const index = stepIndex(currentStep());

      setWizardStep(wizardSteps[Math.max(0, index - 1)]);

    });

  });

  initWizardPrimaryActionSync();

  root.querySelectorAll("[data-kb-step-next]").forEach((button) => {

    button.addEventListener("click", () => {

      const index = stepIndex(currentStep());

      if (mobileCartActionActive()) {

        if (!syncValidationState(true)) {

          const target = validateConfig(currentConfig()).input;

          if (target && typeof target.focus === "function") target.focus();

          return;

        }

        addToCart();

        return;

      }

      setWizardStep(wizardSteps[Math.min(wizardSteps.length - 1, index + 1)]);

    });

  });

  if (mobileOpenButton) {

    mobileOpenButton.addEventListener("click", openMobileConfigurator);

  }

  if (mobileCloseButton) {

    mobileCloseButton.addEventListener("click", closeMobileConfigurator);

  }

  document.addEventListener("keydown", (event) => {

    if (event.key === "Escape" && root.classList.contains("kb-mobile-modal-open")) {

      closeMobileConfigurator();

    }

  });

  root.querySelectorAll("[data-kb-insert]").forEach((button) => {

    button.addEventListener("mousedown", (event) => {

      event.preventDefault();

    });

    button.addEventListener("click", () => {

      insertTextAtCursor(textInsertTarget(), button.dataset.kbInsert || button.textContent || "");

    });

  });

  if (variantInput) variantInput.addEventListener("change", () => {

    updatePrice();

    updateDimensionControls();

    schedulePreview();

  });

  window.addEventListener("scroll", updateMobilePreviewCompact, { passive: true });

  document.addEventListener("scroll", updateMobilePreviewCompact, { passive: true, capture: true });

  document.addEventListener("scroll", updateActiveStepFromScroll, { passive: true, capture: true });

  window.setInterval(updateMobilePreviewCompact, 300);

  window.addEventListener("resize", updateResponsivePreviewState);

  window.addEventListener("resize", syncMobileConfiguratorMode);

  window.addEventListener("resize", positionDimensionMarkers);

  if (addButton) addButton.addEventListener("click", addToCart);

  document.querySelectorAll("[data-kb-mobile-add]").forEach((button) => {

    button.addEventListener("click", addToCart);

  });

  mountMobileCheckoutBar();

  const incomingConfigApplied = applyIncomingConfigFromUrl();

  selectPreferredDefaultVariant();

  updateMobileOpenButtonLabel();

  const localDraftRestored = !incomingConfigApplied && restoreLocalDraft();
  initialDraftSource = incomingConfigApplied ? "incoming_config" : (localDraftRestored ? "local_draft" : "default");
  if (!incomingConfigApplied && !localDraftRestored && applyLastTextForRelatedProduct()) {
    initialDraftSource = "related_prefill";
  }

  /* Oznaci nedostupne boje i prebaci ih ako ih je doneo sacuvan nacrt.
     Tiho pri ucitavanju — kupca ne docekuje poruka pre nego sto sta uradi. */
  oznaciNedostupneBoje();

  zameniNedostupneBoje(true);

  syncDistancerDefault();

  setPreviewMode("clean");

  setFacadeBackground("light");

  setActiveStep("text");

  renderDimensionOptions();

  updateSwatches();

  updateResponsivePreviewState();

  updateActiveStepFromScroll();

  initDogSymbolPicker().then(() => {

    updateCartCheck();

  }).catch(() => {});

  initWhatsAppSharing();

  renderPreview();

  scheduleAlternateShapes();

  pripremiPrimereUPoljima();
  initConfiguratorMeasurement();

  autoOpenMobileConfigurator();

})();


